var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 577,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 183 26 L 272.5 26 L 273 26.5 L 273 33.5 L 267 44.5 L 262.5 49 L 262 47.5 L 263 45.5 L 260 37.5 L 257.5 35 L 254.5 33 L 247.5 32 L 242.5 33 L 237 37.5 L 235 40.5 L 234 46.5 L 234 48.5 L 240 58.5 L 224.5 60 L 217 58.5 L 218 55 Q 220.7 56.1 220 53.5 Q 222.8 50.8 222 44.5 Q 220.9 37.1 215.5 34 L 206.5 32 L 201.5 33 L 196 37.5 Q 193.3 41.8 193.5 49 L 192 46 Q 189.3 47.1 190 44.5 L 184.5 34 L 183 34.5 L 183 26 Z M 198 28 L 198 29 L 216 29 L 217 30 L 240 30 L 241 29 L 260 29 L 198 28 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 273.5 35 L 274 39.5 L 273 39.5 L 273.5 35 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 211.5 40 L 213.5 43 L 211.5 40 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 273.5 44 L 274 46.5 L 273 46.5 L 273.5 44 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 202.5 49 L 204.5 52 L 202.5 49 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 100.5 110 L 103.5 111 L 104.5 110 L 190.5 110 L 192.5 110 L 198.5 111 L 206 117.5 L 207 119.5 L 207 211.5 L 201.5 218 L 196.5 220 L 96.5 220 L 89 214.5 L 86 207.5 L 86 123.5 Q 87.8 115.9 93.5 112 L 100.5 110 Z M 103 114 L 97 117 Q 92 120 91 126 L 91 210 L 98 207 L 123 187 L 124 184 L 147 166 L 148 163 L 158 155 Q 160 156 159 154 L 179 136 L 197 117 L 197 114 L 103 114 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 261.5 110 L 354.5 110 L 359.5 111 L 365 115.5 L 368 122.5 L 368 207.5 L 367 212.5 L 364 217 L 357.5 220 L 257.5 220 L 249 213.5 L 247 208.5 L 247 121.5 L 251.5 114 L 256.5 111 L 261.5 110 Z M 263 114 L 257 117 Q 252 120 251 126 L 251 210 L 266 201 L 307 166 L 308 163 L 318 156 L 319 153 L 333 142 L 357 117 L 357 114 L 263 114 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 86.5 294 L 88.5 295 L 138.5 295 L 141 296 L 143 299.5 L 143 314.5 L 142 316.5 Q 144.5 318 143 323.5 L 141 329.5 L 138.5 332 L 135.5 333 Q 134.3 330.8 129.5 332 L 126 333 L 125.5 331 Q 122.5 334 115.5 333 L 112.5 332 L 109.5 333 L 107.5 332 L 105.5 333 L 103.5 332 L 98.5 333 L 96.5 332 L 94.5 333 L 93.5 332 L 82 332 Q 83.1 329.3 80.5 330 L 79 328.5 L 79 298.5 L 82.5 295 L 86.5 294 Z M 89 303 L 83 308 Q 84 310 81 309 L 80 314 L 82 315 L 80 315 L 81 323 Q 84 328 92 330 Q 99 331 102 328 L 107 320 L 107 314 L 105 309 L 102 305 L 100 306 L 100 305 Q 97 301 89 303 Z M 123 303 L 120 305 L 113 315 Q 112 317 115 316 L 116 325 L 122 329 Q 127 328 129 330 L 137 327 L 141 321 Q 140 316 142 315 L 139 310 Q 140 306 138 307 Q 136 303 135 306 L 134 304 Q 131 302 123 303 Z M 106 304 L 106 306 L 108 305 L 106 304 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 317.5 295 L 373.5 295 L 376 297.5 L 377 299.5 L 377 327.5 L 376 330 Q 372.9 329.3 373.5 332 L 368.5 332 L 366.5 332 L 354.5 333 L 352.5 332 Q 350.7 334.8 344.5 333 L 341.5 332 Q 340 334.5 334.5 333 L 330.5 332 Q 329.3 334.3 324.5 333 L 322.5 333 Q 316.1 332.9 314 328.5 L 313 326.5 L 313 299.5 L 315 296 L 317.5 295 Z M 322 303 Q 323 306 320 305 L 315 311 L 314 316 L 314 320 L 317 326 L 327 330 Q 333 331 336 328 L 341 321 L 340 310 Q 336 301 322 303 Z M 358 303 L 352 306 L 349 311 Q 350 315 348 317 Q 350 318 349 323 Q 352 329 360 330 L 365 330 L 373 326 L 375 323 Q 377 311 372 306 L 367 303 L 358 303 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62.5 336 L 63 338.5 L 62 338.5 L 62.5 336 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62.5 345 L 63 352.5 L 62 352.5 L 62.5 345 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62.5 404 L 63 406.5 L 62 406.5 L 62.5 404 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 388.5 443 L 389 445.5 L 388 445.5 L 388.5 443 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 77.5 448 L 200 448.5 L 80 453 L 69.5 486 L 69 481.5 L 71 477.5 Q 71 466.5 75 459.5 L 76 449.5 L 77.5 448 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 65.5 455 L 66 457.5 L 65 457.5 L 65.5 455 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 391.5 457 L 392 459.5 L 391 459.5 L 391.5 457 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62.5 472 L 63 474.5 L 62 474.5 L 62.5 472 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 394.5 474 L 395 476.5 L 394 476.5 L 394.5 474 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100,135,145)",
    stroke: "rgb(100,135,145)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 59.5 489 L 60 491.5 L 59 491.5 L 59.5 489 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 273.5 26 L 274 34.5 L 273 34.5 L 273.5 26 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 197.5 28 L 260 28.5 L 240.5 29 L 239.5 30 L 216.5 30 L 215.5 29 L 197.5 29 L 197.5 28 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 273.5 40 L 274 43.5 L 273 43.5 L 273.5 40 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 201.5 44 L 202 46.5 L 201 46.5 L 201.5 44 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 253.5 49 L 251.5 52 L 253.5 49 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 284.5 49 L 287 49.5 L 284.5 50 L 284.5 49 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 108.5 64 L 112 64.5 L 108.5 65 L 108.5 64 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 345.5 64 L 349 64.5 L 345.5 65 L 345.5 64 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 95.5 67 L 99 67.5 L 95.5 68 L 95.5 67 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 358.5 67 L 362 67.5 L 358.5 68 L 358.5 67 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 72.5 76 L 70.5 79 L 72.5 76 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 102.5 114 L 196.5 114 L 197 116.5 L 178.5 136 L 159 153.5 Q 159.8 155.8 157.5 155 L 148 163 L 146.5 166 L 124 184 L 122.5 187 L 97.5 207 L 91 210 L 91 125.5 Q 92.3 119.8 96.5 117 L 102.5 114 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 262.5 114 L 356.5 114 L 357 116.5 L 332.5 142 L 319 153 L 317.5 156 L 308 163 L 306.5 166 L 265.5 201 L 251 210 L 251 125.5 Q 252.3 119.8 256.5 117 L 262.5 114 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 63.5 253 L 69 255 L 69.5 257 L 71.5 256 L 76 257 L 76.5 259 L 79.5 258 L 97.5 263 L 101.5 266 L 104.5 265 L 112.5 269 L 114.5 269 L 144 276 Q 142.6 280 149.5 278 L 157.5 282 L 159.5 281 L 164.5 282 L 168.5 285 L 170.5 284 L 199 292.5 L 198.5 294 L 201.5 293 L 229.5 301 L 232.5 299 L 238.5 299 L 242.5 296 L 247.5 296 L 255.5 293 L 257 293.5 Q 256.1 290.1 261.5 292 L 264.5 290 Q 273.1 289.6 278.5 286 L 283.5 286 L 291.5 282 Q 297.6 282.6 300.5 280 Q 302 282.5 303.5 279 L 307.5 279 L 316.5 275 L 319.5 275 L 321.5 275 L 327.5 272 L 335.5 271 L 338.5 269 Q 347.1 268.6 352.5 265 L 356.5 265 L 376.5 258 L 382.5 258 L 390.5 254 L 391.5 255 L 394 253.5 L 393.5 258 L 392 257.5 Q 392.8 259.8 390.5 259 L 390.5 257 Q 387.5 256.2 389 260 L 385.5 260 L 379.5 262 L 377.5 261 L 377.5 263 L 376 262.5 Q 376.9 265.9 371.5 264 L 369.5 265 L 368 264.5 Q 368.8 266.8 366.5 266 L 365.5 263 L 365 265 L 363 265.5 L 365 266.5 L 334.5 275 Q 333 272.5 331.5 276 L 325.5 278 L 323.5 278 L 317.5 280 L 316 279.5 Q 316.8 281.8 314.5 281 L 311 280.5 Q 311.8 283.1 308.5 282 L 306.5 283 L 304.5 282 L 304.5 284 Q 303 281.5 301.5 285 L 297.5 284 L 297 286 L 293.5 285 L 293.5 287 L 291 286 Q 292.4 289.7 286.5 288 L 282.5 290 L 281 289.5 Q 281.9 292.5 277.5 291 L 272.5 293 L 270 292 Q 271.3 295 267.5 294 L 265.5 295 L 263 294 Q 264.1 296.7 261.5 296 Q 260 293.5 258.5 297 L 256.5 296 L 256 298 L 250.5 297 L 250.5 298 L 252 298.5 L 250.5 299 L 248 298 Q 249.3 301 245.5 300 L 243.5 301 L 242 300.5 L 241.5 302 L 238.5 301 L 236 301.5 L 238 302.5 L 230.5 305 L 227.5 303 Q 226 306.5 224.5 304 Q 218.5 304 215.5 301 L 214 301.5 L 214.5 300 L 211.5 301 L 208 299.5 L 210 298.5 L 207.5 298 L 204 299 Q 205.1 296.3 202.5 297 L 200.5 298 L 197 296.5 L 197.5 295 L 194.5 296 Q 193 292.5 191.5 295 L 187 293.5 L 187.5 292 L 184 293 L 183.5 291 L 179.5 292 L 174.5 289 L 172.5 289 L 165 287.5 L 165.5 286 L 162.5 287 L 155 284.5 L 155.5 283 L 152.5 284 L 151.5 282 L 148.5 283 L 142.5 280 L 141 280.5 L 140.5 279 L 138.5 280 L 131.5 277 L 129.5 277 L 120 275 Q 121.1 272.3 118.5 273 L 116.5 274 L 103 270 L 101.5 267 L 100 267.5 L 100.5 269 L 85.5 264 L 81.5 264 L 79.5 262 L 77.5 262 L 67.5 260 L 63 257.5 L 63.5 253 Z M 353 266 L 354 268 L 356 268 L 353 266 Z M 348 269 L 348 270 L 350 270 L 348 269 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 62.5 339 L 63 344.5 L 62 344.5 L 62.5 339 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 411.5 353 L 412 403.5 L 410 404.5 L 411 403.5 L 411.5 353 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 62.5 407 L 63 429.5 L 62 429.5 L 62.5 407 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 67.5 443 L 68 446.5 L 67 446.5 L 67.5 443 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 389.5 446 L 390 449.5 L 389 449.5 L 389.5 446 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 64.5 458 L 65 461.5 L 64 461.5 L 64.5 458 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 392.5 461 L 393 465.5 L 392 465.5 L 392.5 461 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 61.5 476 L 62 478.5 L 61 478.5 L 61.5 476 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 395.5 478 L 396 482.5 L 395 482.5 L 395.5 478 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 58.5 492 L 59 494.5 L 58 494.5 L 58.5 492 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(136,176,188)",
    stroke: "rgb(136,176,188)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 398.5 494 L 399 496.5 L 398 496.5 L 398.5 494 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 433 0 L 433 577 L 0 577 L 0 0 Z M 182 26 L 182 46 L 178 48 L 162 51 L 155 54 L 149 54 L 141 57 L 139 57 L 118 62 Q 116 65 115 63 L 95 67 L 79 72 L 69 78 L 63 90 L 63 99 L 62 100 L 62 111 L 47 111 L 45 113 L 45 125 L 47 126 L 54 126 L 54 322 L 53 323 L 51 322 L 45 323 L 45 336 L 62 336 L 62 353 L 61 354 L 60 353 L 45 353 L 45 405 L 46 405 L 62 405 L 62 432 L 58 432 L 58 443 L 67 443 L 66 455 L 63 464 L 63 471 L 60 481 L 60 488 L 57 496 L 57 504 L 56 505 L 51 504 L 48 517 L 56 520 L 63 520 L 71 523 L 78 523 L 85 526 L 95 527 L 99 529 L 118 532 L 127 535 L 132 535 L 140 538 L 146 538 L 153 541 L 160 541 L 167 544 L 174 544 L 181 547 L 187 547 L 195 550 L 200 550 L 224 556 L 234 556 L 244 553 L 249 553 L 268 548 L 278 547 L 286 544 L 293 544 L 300 541 L 308 541 L 315 538 L 321 538 L 344 532 L 364 529 L 373 526 L 378 526 L 386 523 L 393 523 L 401 520 L 408 520 L 409 519 L 406 510 L 406 504 L 400 505 L 400 499 L 394 474 L 391 451 L 389 446 L 390 443 L 398 443 L 399 440 L 398 437 Q 400 430 394 432 L 394 405 L 412 405 L 412 405 L 412 354 L 411 354 Q 404 356 403 353 L 401 354 L 399 353 L 394 354 L 394 336 L 412 336 L 412 323 L 402 322 L 402 249 L 403 248 L 403 137 L 402 136 L 402 128 Q 404 124 411 126 L 412 125 L 412 113 L 411 111 L 394 111 L 394 93 Q 393 84 388 80 Q 389 77 385 78 L 385 77 L 379 72 L 362 67 L 341 63 L 333 60 L 328 60 L 322 57 L 318 58 L 309 54 L 306 55 L 297 51 L 294 52 L 284 48 L 281 49 L 276 46 L 274 46 L 274 27 L 274 26 L 182 26 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 205.5 40 L 212 41 L 214 46.5 L 212 51 L 207.5 52 L 203 49.5 L 202 44.5 L 205.5 40 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 246.5 40 Q 253 39 254 43.5 Q 255.3 49.8 251.5 51 L 248.5 52 L 243 50 Q 241.3 42 246.5 40 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 280.5 49 L 279.5 51 L 280.5 49 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 172.5 51 L 173 52.5 L 172.5 55 Q 169.8 53.7 172 52.5 L 172.5 51 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 287.5 51 L 289 51.5 L 286.5 53 L 287.5 51 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 291.5 53 L 294.5 55 L 296 54.5 Q 294.3 57.8 292.5 54 L 291.5 53 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 156.5 54 L 159 54.5 Q 156.9 57.8 156.5 54 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 305.5 55 L 308 55.5 L 305.5 56 L 305.5 55 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 146.5 56 L 145.5 58 L 146.5 56 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 309.5 56 L 311.5 59 L 309.5 56 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 318.5 58 L 324 60.5 L 322.5 64 L 322.5 60 L 318.5 59 L 318.5 58 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 316.5 59 L 319 60.5 L 317.5 61 L 316.5 59 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 127.5 61 L 126.5 63 L 125 62.5 L 127.5 61 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 131.5 61 L 134 62.5 L 132.5 62 L 130.5 63 L 131.5 61 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 328.5 61 L 327.5 63 L 328.5 61 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 330.5 61 L 333 61.5 L 329.5 64 L 330 62.5 L 330.5 61 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 114.5 64 L 113.5 66 L 114.5 64 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 116.5 64 L 117 65.5 L 115 66.5 L 116.5 64 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 343.5 64 L 344.5 66 L 343.5 64 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 101.5 67 L 104 68.5 L 102.5 69 L 100.5 69 Q 98.3 68.3 99 70.5 L 98 70.5 L 99.5 68 L 101.5 67 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 355.5 67 Q 360.3 67.3 362 70.5 Q 360.3 68.9 358.5 72 L 357 70.5 L 360 69.5 Q 354.8 69.3 355.5 67 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 355.5 69 L 354.5 71 L 355.5 69 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 363.5 69 Q 365 72.5 366.5 70 L 368 70.5 L 365.5 72 L 363 71.5 L 363.5 69 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 88.5 70 L 90 70.5 L 87.5 72 L 88.5 70 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 92.5 70 L 94 70.5 L 91.5 72 L 92.5 70 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 79.5 73 L 80.5 75 L 79.5 73 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 378.5 74 L 381 75 L 381.5 77 L 383 76.5 L 382.5 79 L 378.5 74 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 377.5 76 L 379 78.5 L 378 78.5 L 377.5 77 L 376 77.5 L 377.5 76 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 70.5 79 Q 73.3 80.3 71 81.5 L 70.5 83 L 70 81.5 L 70.5 79 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 386.5 79 Q 384.9 80.8 388 82.5 L 386.5 84 L 385.5 81 L 384 81.5 L 386.5 79 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 388.5 85 L 391 86.5 L 388 88.5 L 389.5 86 L 387.5 87 L 388.5 85 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 93.5 104 L 200.5 104 Q 208.1 105.9 212 111.5 L 214 117.5 L 214 213.5 L 213 217.5 L 209.5 222 L 202.5 226 L 91.5 226 L 85 222.5 Q 85.8 220.3 83.5 221 L 80 214.5 L 80 121.5 L 79 120.5 L 82 111.5 L 86.5 107 L 93.5 104 Z M 98 109 L 91 113 L 85 122 L 85 210 L 88 214 L 88 216 Q 91 215 90 218 L 97 221 L 194 221 L 195 222 L 204 218 L 208 212 L 208 119 L 205 115 L 198 109 L 98 109 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 253.5 104 L 361.5 104 L 371 109.5 L 375 117.5 L 375 212.5 Q 373.8 220.8 367.5 224 L 363.5 226 L 252.5 226 Q 245.3 224.2 242 218.5 L 240 212.5 L 240 117.5 L 246 107 L 253.5 104 Z M 259 109 L 248 115 L 246 122 L 246 211 L 248 215 L 257 221 L 263 221 L 265 221 L 352 221 L 353 222 L 363 219 Q 367 216 369 210 L 369 121 L 366 115 L 358 109 L 259 109 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 397.5 125 L 402 126.5 L 402 128.5 L 402 321.5 L 401.5 322 L 394 322 L 394 258.5 L 395 257.5 L 394 253.5 L 394 251.5 L 395 246.5 L 394 245.5 L 394 126 L 397.5 125 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 55 126 L 61.5 126 L 62 126.5 L 62 322 L 55.5 322 L 55 321.5 L 55 126 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 78.5 290 L 143.5 290 L 149 293.5 L 149 296 L 151 296.5 L 151 337 L 148 338.5 Q 148.8 341.1 145.5 340 L 143.5 342 L 77.5 342 L 72 338.5 L 71 336.5 L 70 304.5 Q 72.8 302.7 71 296.5 L 73.5 293 L 78.5 290 Z M 82 293 L 77 295 L 73 300 L 73 333 L 74 335 L 81 339 L 142 339 L 145 338 L 148 334 L 148 299 L 147 296 L 142 293 L 82 293 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 312.5 290 L 377.5 290 L 384 294.5 L 385 296.5 L 385 335.5 L 380.5 341 L 377.5 342 L 312.5 342 L 308 340 Q 309.1 337.3 306.5 338 L 305 336.5 L 305 296.5 L 308.5 292 L 312.5 290 Z M 316 293 L 309 296 L 307 300 L 307 333 L 308 335 L 315 339 L 376 339 L 379 338 L 382 335 Q 381 330 383 329 L 383 304 Q 381 302 382 298 L 375 293 L 316 293 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 409.5 356 L 411 357.5 L 411 383.5 L 410 383.5 L 410 357.5 L 409.5 356 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 211 388 L 215 388.5 L 215 426 L 211 425.5 L 211 388 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 242.5 388 L 246 388.5 L 246 426 L 241 425.5 L 241 389.5 L 242.5 388 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 410.5 400 L 411 402.5 L 410 402.5 L 410.5 400 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 91.5 456 L 107.5 456 L 108 458.5 L 106 462.5 L 106 471.5 L 103 479.5 L 102 490.5 L 100 494.5 L 100 500.5 L 98.5 502 L 82 500 L 82 492.5 L 85 485.5 L 86 475.5 L 90 463.5 L 90 457.5 L 91.5 456 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 128 456 L 144.5 456 L 145 457.5 L 144 458.5 L 144 467.5 L 142 472.5 L 142 480.5 L 141 481.5 L 138 509 L 120 507 L 121 492.5 L 124 483.5 L 124 473.5 L 128 456 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 164 456 L 181.5 456 Q 182.6 456.1 182 461.5 L 181 462.5 L 181 472.5 L 179 483.5 L 178 514.5 L 176.5 516 L 159 514 L 159 502.5 L 162 485.5 L 164 456 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 201 456 L 217.5 456 L 218 456.5 L 218 522.5 Q 216.8 525.3 215.5 523 L 203.5 522 L 198 519.5 L 199 516.5 L 199 499.5 L 200 498.5 L 201 456 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 238 456 L 254.5 456 L 255 459.5 L 256 460.5 L 258 521 L 239 524 L 239 474.5 L 238 472.5 L 238 470.5 L 238 456 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 275 456 L 293 456 L 293 463.5 L 294 464.5 L 294 479.5 L 297 494.5 L 297 506.5 L 298 507.5 L 298 514 L 286.5 515 L 280.5 517 L 279 515.5 Q 280.8 509.2 278 507.5 L 278 491.5 L 277 490.5 L 277 477.5 L 276 476.5 L 275 456 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 312 456 L 328.5 456 L 329 458.5 L 332 470.5 L 333 484.5 L 336 493.5 Q 335.3 502.1 337 507 L 319.5 509 L 318 507.5 L 318 500.5 L 316 492.5 L 315 476.5 L 312 464.5 L 312 456 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 348.5 456 L 365.5 456 L 366 458.5 L 370 472.5 L 371 481.5 L 373 485.5 L 375 500 L 357 502 L 357 497.5 L 354 488.5 L 353 477.5 L 351 472.5 L 350 461.5 L 348.5 456 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 67 501 L 70 502.5 Q 71.2 507.1 66 505 L 67 501 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 387 502 Q 392.6 500.1 391 505 Q 385.4 506.9 387 502 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 89.5 506 L 92 507.5 L 90.5 510 Q 86.8 511.3 88 507.5 L 89.5 506 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 366.5 506 L 370 507.5 L 368.5 510 L 365 508.5 L 366.5 506 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 111.5 510 L 113 513.5 L 110.5 515 L 109 512.5 L 111.5 510 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 344 511 L 348 512.5 L 346.5 515 Q 341.9 516.2 344 511 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 131 516 Q 136.6 514.1 135 519 L 132.5 520 L 131 516 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 322 516 L 327 516 L 327 517.5 Q 324.5 522.5 322 517.5 L 322 516 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 152 520 Q 158 518 156 524 L 152 522.5 L 152 520 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 301 520 Q 306.2 517.9 305 522.5 L 302.5 524 L 301 520 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 174.5 525 L 178 526.5 L 176.5 529 L 173 527.5 L 174.5 525 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 280.5 525 Q 285.1 523.8 283 529 L 279 527.5 L 280.5 525 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 197.5 529 Q 202 531 198.5 533 Q 194.1 534.5 195 531.5 L 197.5 529 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,1)",
    stroke: "rgb(2,1,1)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 259.5 529 L 262 530.5 Q 263.2 535.1 258 533 L 259.5 529 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 182.5 26 L 183 45.5 L 182 45.5 L 182.5 26 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 244.5 41 L 243.5 43 L 244.5 41 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 252.5 41 L 253.5 43 L 252.5 41 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 242.5 44 L 243 47.5 L 242 47.5 L 242.5 44 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 254.5 44 L 255 47.5 L 254 47.5 L 254.5 44 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 294.5 51 L 297 51.5 L 294.5 52 L 294.5 51 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 148.5 54 L 151 54.5 L 148.5 55 L 148.5 54 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 135.5 57 L 138 57.5 L 135.5 58 L 135.5 57 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 319.5 57 L 322 57.5 L 319.5 58 L 319.5 57 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 123.5 60 L 127 60.5 L 123.5 61 L 123.5 60 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 330.5 60 L 333 60.5 L 330.5 61 L 330.5 60 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 112.5 63 L 115 63.5 L 112.5 64 L 112.5 63 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 99.5 66 L 102 66.5 L 99.5 67 L 99.5 66 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 78.5 72 L 77.5 74 L 78.5 72 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 377.5 72 L 380 73.5 L 378.5 73 L 377.5 72 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 383.5 75 L 384.5 77 L 383.5 75 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 388.5 80 L 389.5 82 L 388.5 80 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 67.5 81 L 67 82.5 L 66.5 84 L 66 82.5 L 67.5 81 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 63.5 89 L 64 92.5 L 63 92.5 L 63.5 89 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 393.5 92 L 394 94.5 L 393 94.5 L 393.5 92 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 46.5 111 L 62 111.5 L 46 112 L 45.5 116 L 45 112.5 L 46.5 111 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 394.5 111 L 410.5 111 L 412 112.5 L 412 124.5 L 410.5 126 L 405 125.5 L 411 125 L 411 112 L 394.5 112 L 394.5 111 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 45.5 121 L 46 125 L 53 125.5 L 46.5 126 Q 43.8 124.8 45.5 121 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 63.5 246 L 89.5 254 L 93.5 254 L 110.5 260 L 117.5 261 L 124.5 264 L 131.5 265 L 138.5 268 L 142.5 268 L 148.5 271 L 152.5 271 L 173.5 278 L 191.5 282 L 222.5 292 L 229.5 293 L 392.5 246 Q 395.3 247.3 394 252.5 L 391.5 255 L 389.5 255 Q 384.3 254.8 382.5 258 L 376.5 258 L 373.5 260 L 352 265.5 L 356 267.5 L 352.5 269 L 351.5 266 L 342 268.5 L 344 269.5 L 342.5 270 L 338.5 269 L 335.5 271 L 324.5 273 L 320.5 276 L 316.5 275 Q 312.2 279.2 303.5 279 L 301.5 281 L 299.5 281 L 291.5 282 L 283.5 286 L 278.5 286 L 261.5 292 L 257 292 L 256.5 294 L 253.5 293 L 253.5 295 L 250.5 294 L 248 295.5 L 248.5 297 Q 247.2 294.8 242.5 296 L 238.5 299 Q 231.5 298 228.5 301 L 224.5 300 L 223 300.5 L 223.5 299 L 219.5 299 L 213.5 296 L 209.5 296 L 200.5 293 L 199.5 296 L 199.5 294 L 198 293.5 L 198.5 292 L 184.5 289 L 183 289.5 L 183.5 288 L 169.5 284 Q 168 286.5 166.5 283 L 160.5 282 L 159 282.5 L 159.5 281 L 157.5 282 L 153.5 279 L 144 278 Q 145.3 274.7 140.5 276 L 113.5 268 L 111.5 268 L 102.5 265 Q 101 267.5 99.5 264 L 77.5 258 L 77.5 260 L 76 257 L 70.5 256 L 69 256.5 Q 69.8 254.3 67.5 255 L 63 252.5 L 63.5 246 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 391.5 256 L 392.5 258 L 391.5 257 L 389 258.5 Q 388.3 256.3 390.5 257 L 391.5 256 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 65.5 257 L 68 258.5 L 66.5 258 L 65.5 257 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 377.5 261 L 379 261.5 L 376.5 263 L 377.5 261 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 367.5 262 L 370 263.5 L 368 264.5 L 368.5 263 L 367.5 262 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 365.5 263 Q 368.5 264.5 365.5 266 L 362 264.5 L 363.5 265 Q 366 265.7 365.5 263 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 93.5 265 L 96 266.5 L 94.5 266 L 93.5 265 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 100.5 267 L 103 268.5 L 101.5 269 L 100.5 267 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 347.5 269 L 350 269.5 L 347.5 270 L 347.5 269 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 136.5 276 L 138 276.5 L 135.5 278 L 136.5 276 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 325.5 276 L 327 276.5 L 324.5 278 L 325.5 276 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 304.5 280 L 304.5 282 L 307.5 281 L 307.5 282 L 303.5 284 L 303 281.5 L 304.5 280 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 153.5 283 L 156 283.5 L 153.5 284 L 153.5 283 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 163.5 285 L 166 286.5 L 164.5 287 L 163.5 285 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 289.5 285 L 292.5 286 L 294.5 285 L 294.5 286 L 291.5 287 L 289.5 285 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 284.5 287 L 283.5 289 L 284.5 287 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 280.5 288 L 281.5 290 L 279.5 290 L 278 289.5 L 280.5 288 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 274.5 289 L 277 290.5 L 275.5 291 L 274.5 289 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 272.5 291 L 271.5 293 L 270 292.5 L 272.5 291 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 250.5 297 L 254 297.5 L 248.5 299 L 248.5 298 L 250.5 297 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 207.5 298 L 210 298.5 L 207.5 299 L 207.5 298 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 213.5 300 L 215.5 301 L 217.5 300 L 220 301.5 L 218.5 302 L 216.5 301 L 214.5 301 L 213.5 300 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 236.5 301 L 239 301.5 L 236.5 302 L 236.5 301 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 227.5 303 L 230 304.5 L 226.5 305 L 227.5 303 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 406.5 322 L 409 322.5 L 406.5 323 L 406.5 322 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 45.5 323 L 46 335.5 L 45 335.5 L 45.5 323 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 411.5 323 L 412 336 L 410 335.5 L 411 334.5 L 411.5 323 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 45.5 404 L 57 404.5 L 45.5 405 L 45.5 404 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 59.5 404 L 62 404.5 L 59.5 405 L 59.5 404 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 396.5 404 L 410 404.5 L 396.5 405 L 396.5 404 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 58 432 L 61 432.5 L 59 433 L 58.5 443 L 58 432 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 394.5 432 L 398 432.5 L 394.5 433 L 394.5 432 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 398.5 437 L 399 439.5 L 398 439.5 L 398.5 437 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 66.5 448 L 67 450.5 L 66 450.5 L 66.5 448 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 390.5 450 L 391 452.5 L 390 452.5 L 390.5 450 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 63.5 463 L 64 467.5 L 63 467.5 L 63.5 463 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 60.5 480 L 61 484.5 L 60 484.5 L 60.5 480 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 396.5 483 L 397 486.5 L 396 486.5 L 396.5 483 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 57.5 495 L 58 498.5 L 57 498.5 L 57.5 495 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 399.5 498 L 400 503.5 L 399 503.5 L 399.5 498 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 51.5 504 L 55 504.5 L 51.5 505 L 51.5 504 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 402.5 504 L 406 504.5 L 402.5 505 L 402.5 504 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 49.5 510 L 50 512.5 L 49 516.5 L 49.5 518 Q 47.3 517.3 48 513.5 L 49.5 510 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 408.5 516 L 409 518.5 L 405.5 520 L 405.5 519 Q 409.5 520.1 408.5 516 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 55.5 519 L 59 519.5 L 55.5 520 L 55.5 519 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 70.5 522 L 73 522.5 L 70.5 523 L 70.5 522 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 389.5 522 L 393 522.5 L 389.5 523 L 389.5 522 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 361.5 528 L 364 528.5 L 361.5 529 L 361.5 528 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 108.5 530 L 111 530.5 L 108.5 531 L 108.5 530 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 351.5 530 L 354 530.5 L 351.5 531 L 351.5 530 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 112.5 531 L 115 531.5 L 112.5 532 L 112.5 531 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 346.5 531 L 349 531.5 L 346.5 532 L 346.5 531 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 126.5 534 L 129 534.5 L 126.5 535 L 126.5 534 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 331.5 534 L 334 534.5 L 331.5 535 L 331.5 534 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 139.5 537 L 143 537.5 L 139.5 538 L 139.5 537 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 317.5 537 L 321 537.5 L 317.5 538 L 317.5 537 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 152.5 540 L 155 540.5 L 152.5 541 L 152.5 540 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 303.5 540 L 308 540.5 L 303.5 541 L 303.5 540 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 166.5 543 L 169 543.5 L 166.5 544 L 166.5 543 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 289.5 543 L 293 543.5 L 289.5 544 L 289.5 543 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 180.5 546 L 183 546.5 L 180.5 547 L 180.5 546 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 275.5 546 L 278 546.5 L 275.5 547 L 275.5 546 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 194.5 549 L 197 549.5 L 194.5 550 L 194.5 549 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 209.5 552 L 212 552.5 L 209.5 553 L 209.5 552 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 246.5 552 L 249 552.5 L 246.5 553 L 246.5 552 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(248,241,229)",
    stroke: "rgb(248,241,229)",
    strokeWidth: 1,
    opacity: 0.8431372549019608,
    d: "M 231.5 555 L 234 555.5 L 231.5 556 L 231.5 555 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 71.5 91 L 78.5 92 L 80.5 91 L 81.5 92 L 223.5 92 L 225.5 92 L 229.5 91 L 231.5 92 L 232.5 91 L 385.5 91 Q 387.8 91.8 387 95.5 L 386 98.5 L 387 99.5 L 387 114.5 L 388 115.5 L 387 116.5 L 387 124.5 L 388 127.5 L 387 128.5 L 387 238 Q 384.3 236.9 385 239.5 L 380.5 242 L 376.5 242 L 366.5 246 L 337.5 254 L 333.5 254 Q 332.1 257.6 326.5 257 Q 325 254.5 323.5 258 L 319.5 259 Q 318.3 255.8 312.5 257 L 312.5 258 Q 317 257 318 259.5 L 274.5 272 L 272.5 271 L 272.5 273 L 262.5 275 L 256.5 273 L 257 274.5 L 257.5 276 L 260.5 275 L 260.5 276 L 250.5 278 L 244.5 281 L 242.5 281 L 239.5 280 L 239.5 282 L 232.5 284 L 230 283 Q 231.3 286.3 226.5 285 Q 225 281.5 223.5 284 L 198.5 276 L 184 273 L 183.5 271 L 181.5 272 L 179.5 270 L 174.5 270 L 159 265.5 L 160 263.5 L 158.5 264 L 155.5 264 L 151.5 261 L 147.5 262 L 143 260.5 L 148 258.5 L 144.5 258 L 139.5 260 L 136.5 258 L 134.5 258 L 127.5 257 L 117.5 253 L 112.5 253 Q 110.3 249.7 105 249.5 Q 106.3 246.8 107.5 249 L 111.5 250 L 112.5 248 L 104 247 Q 105.3 250.3 100.5 249 Q 96.9 245.6 90 245.5 L 90.5 244 L 87.5 245 L 69 240 L 69 215.5 L 71 215 L 72.5 226 L 73 216.5 L 70.5 211 L 69.5 213 L 69 209.5 L 70 207.5 L 69 206.5 L 69 97.5 L 70 95.5 L 70 93.5 L 71.5 91 Z M 71 93 L 71 95 L 73 94 L 71 93 Z M 230 93 L 229 96 L 230 113 L 230 97 L 231 96 Q 232 92 230 93 Z M 233 94 Q 233 97 235 95 L 238 96 L 241 95 L 248 98 L 248 97 L 250 97 L 253 96 L 255 97 L 253 98 L 256 98 L 258 95 L 351 95 L 354 97 L 353 96 L 355 95 L 357 95 Q 360 94 359 97 L 361 96 L 361 98 L 364 97 Q 367 98 366 95 Q 371 93 370 97 Q 373 98 372 95 Q 375 94 374 97 L 372 98 L 375 98 L 377 98 Q 380 99 378 95 L 382 95 L 384 98 L 384 96 L 386 96 L 384 94 L 233 94 Z M 73 95 L 71 97 L 72 101 L 73 97 L 73 95 Z M 251 99 L 242 103 L 238 107 L 235 114 L 235 217 L 238 225 Q 241 230 249 230 L 249 232 L 245 230 L 245 232 L 243 231 Q 240 230 241 233 L 246 234 L 256 234 L 252 232 L 252 231 L 360 231 L 361 232 L 370 230 L 375 227 L 378 221 L 380 221 L 382 220 L 382 215 L 380 215 L 381 210 L 381 129 L 380 128 L 380 116 L 381 115 L 379 114 L 379 111 L 376 104 L 364 99 L 362 99 L 360 100 L 356 99 L 257 99 L 256 100 L 251 99 Z M 379 99 L 381 105 L 383 104 L 384 107 L 385 104 Q 386 100 382 102 L 382 99 L 379 99 Z M 89 100 L 83 103 Q 77 107 75 114 L 75 218 L 78 224 L 83 228 L 92 231 L 94 230 L 96 231 L 201 231 L 210 229 L 213 227 Q 218 223 219 216 L 219 116 L 217 109 Q 213 103 206 100 L 89 100 Z M 242 100 L 242 101 L 244 101 L 242 100 Z M 373 100 L 375 103 L 376 103 L 373 100 Z M 73 102 Q 70 105 71 112 L 73 111 L 72 108 L 73 106 L 73 102 Z M 234 106 Q 233 109 236 108 Q 237 105 234 106 Z M 380 106 L 379 109 L 380 109 L 380 106 Z M 233 108 L 233 115 L 234 115 Q 235 109 233 108 Z M 383 108 L 384 116 L 385 114 L 385 116 L 386 116 L 386 108 L 385 112 L 383 108 Z M 381 109 L 380 112 L 381 112 L 381 109 Z M 73 113 L 72 119 L 73 119 L 73 113 Z M 230 114 L 229 274 L 231 274 L 230 273 L 230 215 L 233 214 L 232 212 Q 233 207 230 208 L 230 114 Z M 383 118 L 383 207 L 383 129 L 385 125 L 386 225 L 386 121 L 385 121 L 383 118 Z M 73 120 L 72 129 L 73 129 L 73 120 Z M 234 120 L 232 125 L 233 129 L 234 129 L 234 120 Z M 383 210 Q 380 215 384 214 L 383 210 Z M 236 220 L 234 224 L 236 224 L 236 220 Z M 73 227 Q 70 228 71 234 L 73 235 L 72 231 L 73 229 L 73 227 Z M 236 227 L 236 229 L 239 229 L 236 227 Z M 233 228 L 233 232 L 235 232 L 233 228 Z M 374 229 L 374 232 L 376 231 L 374 229 Z M 367 231 L 367 232 L 369 232 L 367 231 Z M 357 232 L 355 234 L 360 234 Q 361 231 357 232 Z M 355 236 Q 354 239 358 238 Q 359 240 360 238 L 360 236 L 355 236 Z M 365 237 L 365 239 L 361 241 Q 363 244 369 242 L 369 244 L 373 243 L 370 241 Q 367 242 368 239 L 365 237 Z M 73 238 L 73 240 L 75 239 L 78 241 L 81 241 L 73 238 Z M 360 240 L 359 242 L 352 242 L 352 244 L 362 243 L 360 242 L 360 240 Z M 92 243 L 92 244 L 94 244 L 92 243 Z M 97 244 L 100 247 L 104 247 L 97 244 Z M 350 248 L 350 249 L 353 249 L 350 248 Z M 114 249 L 114 250 L 116 250 L 114 249 Z M 332 249 L 332 250 L 335 250 L 332 249 Z M 339 249 L 339 250 L 343 250 L 339 249 Z M 347 249 L 347 250 L 349 250 L 347 249 Z M 121 251 L 121 252 L 126 255 L 130 255 Q 129 252 128 254 Q 125 255 126 252 L 121 251 Z M 336 251 L 334 253 L 336 253 L 336 251 Z M 339 251 L 339 252 L 341 252 L 339 251 Z M 330 253 L 330 255 L 332 254 L 330 253 Z M 132 254 Q 131 257 134 256 Q 135 253 132 254 Z M 136 255 L 136 256 L 138 256 L 136 255 Z M 305 256 L 305 257 L 307 257 L 305 256 Z M 319 256 L 319 257 L 322 257 L 319 256 Z M 140 257 L 140 258 L 142 258 L 140 257 Z M 308 257 L 308 258 L 311 258 L 308 257 Z M 149 259 L 149 260 L 152 260 L 149 259 Z M 310 259 L 310 260 L 314 260 L 310 259 Z M 294 260 L 292 263 Q 297 264 298 262 Q 299 258 294 260 Z M 302 260 Q 301 264 307 262 L 308 260 L 305 261 L 302 260 Z M 161 262 L 161 263 L 164 263 L 161 262 Z M 166 263 L 166 264 L 168 264 L 166 263 Z M 162 264 L 162 265 L 165 265 L 162 264 Z M 169 264 L 166 266 L 169 267 L 176 266 L 176 265 L 173 266 L 169 266 L 171 265 L 169 264 Z M 280 264 L 280 265 L 282 265 L 280 264 Z M 287 264 L 283 266 L 288 267 L 288 265 L 287 264 Z M 293 264 L 293 265 L 295 265 L 293 264 Z M 289 265 L 289 266 L 291 266 L 289 265 Z M 177 266 L 177 267 L 179 267 L 177 266 Z M 273 266 L 273 267 L 278 267 L 273 266 Z M 283 267 L 283 268 L 285 268 L 283 267 Z M 182 268 L 182 269 Q 187 269 189 272 L 192 271 L 182 268 Z M 276 268 L 272 270 L 277 270 L 276 268 Z M 193 271 L 195 273 L 199 273 L 193 271 Z M 201 272 L 199 274 L 204 275 L 207 275 L 201 272 Z M 192 273 L 192 274 L 194 274 L 192 273 Z M 252 273 L 252 274 L 254 274 L 252 273 Z M 263 273 L 263 274 L 265 274 L 263 273 Z M 240 274 L 241 276 Q 248 277 251 275 L 240 274 Z M 209 275 L 210 277 L 214 278 L 219 278 L 209 275 Z M 220 278 L 222 280 L 224 280 L 225 282 L 233 282 L 232 281 Q 233 278 230 279 L 230 281 Q 226 278 220 278 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62.5 100 L 63 111.5 L 62 111.5 L 62.5 100 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 46 112 L 55.5 114 L 58 113 L 57.5 124 L 55.5 124 L 51 123.5 L 54 123 Q 55.1 120.3 52.5 121 L 48.5 122 L 47 121.5 Q 46.2 124.5 50 123 L 50 125 Q 44.4 127.2 46 121.5 L 45 116.5 L 47 116.5 L 46 112 Z M 48 114 L 48 116 Q 50 119 51 116 L 48 114 Z M 54 115 L 54 118 L 57 119 L 56 117 Q 57 114 54 115 Z M 55 119 Q 53 122 56 121 L 55 119 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 408.5 112 L 411 112 L 411 118.5 L 410 121.5 L 411 125 L 403.5 126 L 403.5 125 L 406 123.5 L 403.5 123 L 400.5 124 L 399.5 122 L 401 121.5 Q 397.3 119.6 399 113 L 407.5 113 L 408.5 112 Z M 401 115 L 401 117 L 406 118 L 406 115 L 401 115 Z M 403 120 L 402 123 L 404 122 Q 406 123 405 121 L 403 120 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 379.5 216 L 381 219 Q 377.5 220.1 379.5 216 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 103.5 257 L 106 257.5 L 103.5 258 L 103.5 257 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 227.5 292 L 230 292.5 L 227.5 293 L 227.5 292 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 88.5 306 L 97.5 306 L 100 308.5 Q 102.5 312 101 319.5 L 98.5 323 L 90.5 325 L 85 323 L 82 317.5 L 82 313.5 L 86.5 307 L 88.5 306 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 121.5 306 Q 132 304 135 309.5 L 135 320.5 L 133.5 322 Q 130.5 325 124.5 325 L 117 319.5 L 116 314.5 L 121.5 306 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 322.5 306 Q 332.3 303.8 334.5 309 L 336 308.5 L 335 310.5 L 336 311.5 L 336 320 Q 333.3 318.9 334 321.5 Q 331.3 324.8 325.5 325 L 318 320.5 Q 315.4 319.1 316 314.5 L 320.5 307 L 322.5 306 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 356.5 306 Q 366.8 303.8 369 309.5 L 369.5 312 L 371 311.5 Q 368.8 312.8 370 317.5 L 366.5 323 L 358.5 325 L 353 321.5 Q 349.8 319.2 351 312.5 L 354 307 L 356.5 306 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 53.5 322 L 55.5 325 L 58 324 Q 59.5 329.4 56.5 331 L 55 330.5 Q 54.2 333.5 58 332 L 58 335 Q 54.3 337.3 46 336 L 47 333.5 L 46 331.5 L 46 329.5 Q 44.5 322.5 47.5 323 L 49.5 323 L 53 324 L 53.5 322 Z M 51 324 L 51 327 Q 54 326 51 324 Z M 55 326 L 55 329 L 57 328 L 55 326 Z M 52 332 L 50 334 L 52 334 L 52 332 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 404.5 322 L 408.5 324 L 411 323 L 410 327.5 Q 412.5 329 411 334.5 L 409.5 336 L 399 336 L 399 327.5 L 401 327 L 400 329.5 L 403.5 330 L 402 327.5 L 402 326 Q 398.3 327.5 399 324.5 L 401.5 324 L 404.5 322 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 204 382 L 243.5 382 L 244.5 383 L 248 382 L 248.5 384 L 249 382 Q 252.7 380.5 252 383.5 L 252 385.5 L 253 388.5 L 251 397.5 L 252 401.5 L 248.5 411 L 248 387 L 243.5 386 L 240 387 Q 241 390 238 389 L 238 391.5 L 239 392.5 L 239 422.5 L 235.5 425 L 225.5 426 L 222 424.5 L 225 424 L 225 422 L 220 422 L 219.5 424 L 217 423 L 217 387.5 Q 216.9 386.4 211.5 387 Q 210.2 384.8 209 387.5 L 209 395.5 L 206 396 L 206 397.5 L 209 398.5 L 208.5 411 L 205 400.5 L 205 392.5 L 205.5 390 L 207 389.5 L 204 388.5 L 206 387.5 L 204 387 L 204 382 Z M 207 383 Q 205 386 208 385 L 207 383 Z M 220 384 L 218 386 L 220 387 L 220 384 Z M 249 385 L 249 390 L 249 392 L 251 392 L 250 388 Q 251 384 249 385 Z M 223 386 L 220 387 L 221 392 L 222 388 L 222 392 L 224 391 L 223 386 Z M 207 392 L 206 395 L 207 395 L 207 392 Z M 251 393 L 250 396 L 251 396 L 251 393 Z M 220 398 L 219 401 L 220 401 L 220 398 Z M 223 398 L 223 401 L 225 400 Q 226 397 223 398 Z M 220 416 L 220 417 L 222 417 L 220 416 Z M 233 416 L 232 419 Q 231 421 234 420 L 235 417 L 233 416 Z M 228 420 L 227 422 Q 231 423 232 421 L 228 420 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 61.5 432 L 62.5 433 L 398 433.5 L 396 434 L 396.5 436 L 398 435.5 L 396.5 439 L 395.5 437 L 393 438 L 392.5 436 L 390.5 439 L 386.5 438 L 384.5 439 L 380.5 438 L 376.5 439 Q 374.8 436.3 368.5 438 L 366.5 439 L 365.5 438 L 352.5 438 L 351.5 439 L 342.5 439 L 336 437.5 L 344 436.5 L 311.5 436 L 311.5 437 L 335 437.5 L 320.5 439 L 319.5 438 L 308.5 438 L 307.5 439 L 296.5 439 L 287.5 437 L 276.5 437 Q 275.2 439.2 270.5 438 L 264.5 438 L 253.5 437 L 246.5 439 L 245.5 438 L 195.5 438 L 193.5 437 L 192.5 438 L 168.5 438 Q 166.8 435.2 160.5 437 L 158.5 439 L 145.5 439 L 144.5 438 L 128.5 438 Q 126.7 440.7 120.5 439 Q 118.8 436.3 112.5 438 Q 110.8 440.7 104.5 439 Q 102.8 436.3 96.5 438 L 95.5 439 L 84.5 439 L 80 438 Q 81.3 434.3 75.5 436 L 72 435 Q 70.7 438.3 75.5 437 L 75.5 438 L 62.5 438 L 60.5 439 Q 57.8 437.6 59 433 L 61.5 432 Z M 81 435 L 81 436 L 86 436 L 81 435 Z M 367 435 L 364 437 L 368 437 L 367 435 Z M 371 435 L 371 436 L 376 436 L 371 435 Z M 382 435 L 382 436 L 384 436 L 382 435 Z M 61 436 L 61 438 L 63 437 L 61 436 Z M 89 436 L 89 437 L 91 437 L 89 436 Z M 97 436 L 97 437 L 104 437 L 97 436 Z M 113 436 L 113 437 L 126 437 L 113 436 Z M 129 436 L 129 437 L 136 437 L 129 436 Z M 348 436 L 348 437 L 360 437 L 348 436 Z M 385 436 L 385 437 L 388 437 L 385 436 Z M 108 437 L 108 438 L 112 438 L 108 437 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 59.5 442 L 67 442.5 L 59.5 443 L 59.5 442 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 389.5 442 L 397 442.5 L 389.5 443 L 389.5 442 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 50.5 506 L 51 509.5 L 50 509.5 L 50.5 506 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 54.5 508 L 63.5 509 L 72.5 512 L 77.5 512 L 122.5 523 L 141.5 526 L 145.5 528 L 147.5 528 L 159.5 531 L 164.5 531 L 173.5 534 L 178.5 534 L 191.5 538 L 193.5 538 L 204.5 541 L 211.5 541 L 219.5 544 L 227 544 L 228 547.5 L 227 549.5 L 227 551.5 L 226.5 553 L 212.5 549 L 210.5 550 Q 208.8 546.9 207 548.5 L 206.5 547 L 204.5 548 L 199.5 546 L 195 547 Q 196.1 544.3 193.5 545 L 192 545.5 L 192.5 544 L 190.5 545 L 182.5 542 L 179.5 543 L 178 540 L 171.5 541 L 168.5 539 L 164.5 540 L 164.5 538 L 157.5 538 Q 154.2 535.3 147.5 536 L 133.5 531 L 131.5 531 L 128.5 530 L 124.5 530 L 122 529.5 L 122.5 528 L 120.5 529 L 113.5 528 L 104 526 L 103.5 524 L 98.5 525 L 96.5 522 L 94.5 522 L 90.5 523 L 90.5 521 L 87.5 522 L 85.5 521 L 83.5 522 L 83.5 520 L 81.5 521 L 77.5 519 L 75.5 520 L 75.5 518 L 70.5 519 L 63 517 Q 64.5 513.2 61.5 514 L 61.5 516 L 54.5 514 L 52.5 515 L 51.5 513 Q 52.8 515.3 54 512.5 L 52 512 L 54.5 508 Z M 57 509 Q 54 513 59 512 L 60 510 L 58 511 L 57 509 Z M 60 512 L 57 514 L 60 515 L 60 512 Z M 66 513 L 66 515 L 64 516 L 69 517 L 72 517 L 69 516 L 74 515 Q 71 512 66 513 Z M 78 515 L 79 517 L 77 517 L 77 518 Q 80 519 81 517 L 78 515 Z M 88 518 L 90 520 L 91 520 L 88 518 Z M 101 520 L 102 523 L 100 523 L 100 524 Q 104 525 105 522 L 101 520 Z M 98 521 L 98 522 L 100 522 L 98 521 Z M 106 522 L 104 524 L 111 524 Q 113 525 111 527 L 114 527 L 114 525 L 116 526 L 121 526 L 106 522 Z M 126 527 L 128 529 L 129 529 L 126 527 Z M 130 529 L 130 530 L 132 530 L 130 529 Z M 134 529 L 135 530 L 136 531 Q 137 528 134 529 Z M 138 530 L 137 532 L 140 531 L 138 530 Z M 148 534 L 148 535 L 150 535 L 148 534 Z M 158 535 L 158 536 L 160 536 L 158 535 Z M 173 539 L 173 540 L 175 540 L 173 539 Z M 197 545 L 197 546 L 199 546 L 197 545 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 407.5 513 L 408 515.5 L 407 515.5 L 407.5 513 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 123.5 533 L 126 533.5 L 123.5 534 L 123.5 533 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 335.5 533 L 338 533.5 L 335.5 534 L 335.5 533 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 205.5 551 L 209 551.5 L 205.5 552 L 205.5 551 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 249.5 551 L 252 551.5 L 249.5 552 L 249.5 551 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 219.5 554 L 223 554.5 L 219.5 555 L 219.5 554 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,192,44)",
    stroke: "rgb(245,192,44)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 234.5 554 L 237 554.5 L 234.5 555 L 234.5 554 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 64 90 L 391.5 90 L 392 91.5 L 394 96.5 L 394 112 L 407.5 112 L 409 113.5 L 407.5 113 L 399 113 L 399 119.5 L 400.5 122 L 399 122.5 L 402.5 124 L 402 122.5 L 402.5 120 L 405 120.5 Q 405.8 122.8 403.5 122 L 403.5 123 L 406 123.5 L 404.5 125 L 394 125 L 394 245.5 L 390.5 246 L 379.5 250 L 375.5 250 L 369.5 253 L 361.5 254 L 355.5 257 L 351.5 257 L 330.5 264 L 326.5 264 L 320.5 267 L 312.5 268 L 306.5 271 L 302.5 271 Q 297.1 274.6 288.5 275 L 282.5 278 L 278.5 278 L 257.5 285 L 242.5 288 L 232.5 292 L 224.5 292 L 189.5 281 L 174.5 278 L 154.5 271 L 150.5 271 L 129.5 264 L 125.5 264 L 105.5 257 L 101.5 257 L 94.5 254 L 63 246 L 63 125.5 L 62.5 125 L 54.5 125 L 52.5 125 L 50 125 L 50 123 Q 46.2 124.5 47 121.5 L 47.5 119 L 50 120.5 L 48 121.5 L 51.5 122 L 54 121 L 55 118.5 L 54 115 Q 56.7 113.9 56 116.5 L 57 119 L 55 119.5 L 55.5 121 Q 52.9 120.3 54 123 L 51.5 123 L 51.5 124 L 56 123.5 L 55.5 122 L 58 123.5 L 58 113.5 L 56.5 113 L 54.5 113 L 50 112.5 L 63 112 L 63 94.5 L 64 90 Z M 72 91 L 70 94 L 70 96 L 69 98 L 69 207 L 70 208 L 69 210 L 70 213 L 71 211 L 73 217 L 73 226 L 71 215 L 69 216 L 69 240 L 87 244 L 86 243 L 89 242 L 90 243 L 89 243 L 89 244 L 92 243 L 94 244 L 92 244 L 91 246 Q 96 247 97 244 L 116 250 L 114 250 L 112 250 L 108 249 Q 106 247 105 250 Q 110 250 113 253 Q 119 252 123 255 L 125 255 L 121 252 L 121 251 L 124 252 L 126 252 Q 125 255 128 254 Q 129 252 130 255 L 125 256 L 135 258 L 137 258 L 140 260 L 145 258 L 152 259 L 152 260 L 148 259 L 143 261 L 148 262 L 152 261 L 156 264 Q 160 265 161 262 L 164 263 L 160 263 L 159 266 L 175 270 L 180 270 L 182 272 L 184 271 L 184 273 L 188 274 L 194 273 L 192 271 L 190 272 L 176 266 L 174 267 Q 168 268 166 266 L 168 265 L 168 264 L 165 265 L 161 265 L 166 263 L 171 265 L 170 265 L 170 266 L 174 265 L 199 272 L 201 272 L 207 274 L 207 275 L 199 273 L 192 274 L 192 275 L 196 274 L 197 275 L 195 276 L 207 279 L 209 278 L 210 279 L 208 280 L 224 284 L 223 283 L 224 280 L 219 278 L 210 277 L 209 275 L 228 280 L 232 279 L 233 282 L 225 282 L 227 285 Q 231 286 230 283 L 233 284 L 240 282 L 240 280 L 243 281 L 245 281 L 251 278 L 261 276 L 261 275 L 258 276 L 257 275 L 257 273 L 259 274 L 263 273 L 266 274 L 273 273 L 273 271 L 275 272 L 307 263 L 307 262 Q 301 264 302 260 L 305 261 L 308 260 L 308 262 L 314 261 L 310 260 L 310 259 L 315 260 L 318 260 Q 317 257 312 258 L 319 256 L 322 257 L 319 257 L 320 259 L 324 258 Q 325 254 327 257 Q 332 258 334 254 L 338 254 L 349 251 L 346 250 L 350 248 L 354 249 L 370 245 L 369 244 L 369 242 L 363 242 Q 359 245 352 244 L 352 242 L 359 242 L 359 241 L 360 241 Q 359 243 362 242 L 361 241 L 364 239 L 367 237 L 368 241 L 376 243 L 375 242 L 377 242 Q 383 243 385 240 Q 384 237 387 238 L 387 129 L 388 128 L 387 125 L 387 117 L 388 116 L 387 115 L 387 100 L 386 99 Q 387 95 384 96 L 384 98 L 382 95 L 378 95 Q 379 99 377 98 L 375 98 L 372 97 Q 369 98 370 95 Q 365 93 366 97 L 361 98 L 359 95 L 356 96 L 354 95 L 354 97 L 351 95 L 258 95 L 256 98 L 253 98 L 255 97 L 255 96 L 252 97 L 249 96 L 248 98 L 247 97 L 244 98 L 242 98 L 244 97 L 244 96 L 241 97 L 237 95 L 234 96 L 233 94 L 384 94 L 386 95 L 387 96 Q 388 92 386 91 L 233 91 L 232 92 L 230 91 L 226 92 L 224 92 L 82 92 L 81 91 L 79 92 L 72 91 Z M 372 95 Q 371 98 374 97 Q 375 94 372 95 Z M 371 243 L 371 244 L 373 244 L 371 243 Z M 97 245 L 95 247 L 101 249 Q 105 250 104 247 Q 99 248 97 245 Z M 350 249 L 350 250 L 353 250 L 350 249 Z M 263 274 L 263 275 L 265 275 L 263 274 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 71 93 L 73 93.5 L 73 95.5 L 71.5 101 L 71 96.5 L 71 94.5 L 71 93 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 229.5 93 Q 232.1 92.2 231 95.5 L 230 96.5 L 229.5 113 L 229 95.5 L 229.5 93 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 366.5 98 L 366.5 100 L 372.5 102 L 371.5 99 L 376 102.5 L 374 103.5 L 376 104 L 379 110.5 L 379 114 Q 381.7 115.1 381 112.5 L 379 106.5 L 380 106.5 L 381.5 112 L 382.5 108 L 384.5 112 L 385.5 108 L 386 115.5 L 385 115.5 L 384.5 114 L 383.5 116 L 382.5 112 L 380 115.5 L 380 127.5 L 381 128.5 L 381 209.5 L 380 215 L 382 215 L 382 220 L 379.5 221 L 378 220.5 L 375 226.5 L 375.5 228 L 373.5 227 Q 371.4 230.4 366 230.5 L 369 231.5 L 366.5 232 L 361.5 231 L 360 234 L 355 233.5 L 360 231.5 L 251.5 231 L 251.5 232 L 256 233.5 L 245.5 234 L 241 233 L 240 230.5 L 241.5 231 L 244.5 232 L 244.5 230 L 246 229.5 L 243.5 229 L 242 229.5 Q 244.3 228.3 241.5 227 L 240.5 229 L 240 227.5 L 240.5 226 L 238 224.5 L 236.5 220 L 236 224 L 234 223.5 L 236 217.5 L 235 216.5 L 235 113.5 L 238 106.5 L 241 103.5 L 240.5 102 L 242.5 103 Q 245.7 98.7 253.5 99 L 255.5 100 L 256.5 99 L 355.5 99 L 359.5 100 L 361.5 99 L 363.5 99 L 366.5 98 Z M 255 103 L 247 106 Q 242 109 240 116 L 240 128 L 239 129 L 239 210 Q 241 211 240 216 L 243 222 L 249 226 L 253 227 L 363 227 L 371 223 L 375 217 L 375 115 L 373 111 Q 369 104 361 103 L 255 103 Z M 380 216 Q 377 220 381 219 L 380 216 Z M 247 230 L 248 231 L 249 232 Q 250 229 247 230 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 240.5 99 L 244 100.5 L 241.5 101 L 240.5 99 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 379 99 L 382 99 L 382 102 Q 385.7 100.5 385 103.5 L 383.5 107 L 382.5 104 L 381 104.5 L 379 99 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 88.5 100 L 205.5 100 Q 212.9 102.6 217 108.5 L 219 115.5 L 219 215.5 Q 217.6 223 212.5 227 L 209.5 229 L 200.5 231 L 95.5 231 L 93.5 230 L 91.5 231 L 82.5 228 L 78 223.5 L 75 217.5 L 75 113.5 Q 77.3 106.8 82.5 103 L 88.5 100 Z M 95 103 L 87 106 Q 81 109 79 117 L 79 215 L 82 221 Q 85 226 93 227 L 202 227 L 209 224 L 214 218 Q 213 213 215 212 L 215 119 L 212 111 Q 208 104 200 103 L 95 103 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 72.5 102 L 73 105.5 L 72 107.5 L 74 111.5 L 71 111.5 Q 70.1 105.1 72.5 102 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 234 106 Q 237 105 236 108 Q 233 109 234 106 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 232.5 108 Q 235.3 109.3 234 114.5 L 233 114.5 L 232.5 108 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 47.5 113 L 51 115.5 Q 49.5 118.5 48 115.5 L 47.5 114 L 46.5 117 L 46 114.5 L 47.5 113 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 72.5 113 L 73 118.5 L 72 118.5 L 72.5 113 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 229.5 114 L 230 208 Q 233.3 206.7 232 211.5 L 233 213.5 L 230 214.5 L 230 272.5 L 231 273.5 L 229 274 L 229.5 114 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 401 115 L 406 115 L 406 118 L 401 117 L 401 115 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 382.5 118 L 384.5 121 L 386 120.5 L 385.5 225 L 384.5 125 L 383 128.5 L 382.5 207 L 382.5 118 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 72.5 120 L 73 128.5 L 72 128.5 L 72.5 120 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 233.5 120 L 234 128.5 L 233 128.5 L 232 124.5 L 233.5 120 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 382.5 210 L 384 214 Q 380.2 215.2 382.5 210 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 72.5 227 L 73 228.5 L 72 230.5 L 73 234.5 L 71 233.5 Q 69.8 228.3 72.5 227 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 236 227 L 239 228.5 L 236 229 L 236 227 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 232.5 228 L 235 231.5 L 233 232 L 232.5 228 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 373.5 229 L 376 230.5 L 374 231.5 L 373.5 229 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 355 236 L 360 236 L 360 237.5 Q 358.8 240.3 357.5 238 Q 353.8 239 355 236 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 73 238 L 81 240.5 L 77.5 241 L 74.5 239 L 73 239.5 L 73 238 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 336.5 248 L 342.5 249 L 344 250.5 L 342.5 250 Q 336.8 250.8 336.5 248 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 331.5 249 L 335 249.5 L 331.5 250 L 331.5 249 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 336.5 250 L 336 251.5 Q 336.8 253.8 334.5 253 L 336.5 250 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 338.5 251 L 341 251.5 L 338.5 252 L 338.5 251 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 330 253 L 332 253.5 L 330 254.5 L 330 253 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 132 254 Q 135 253 134 256 Q 131 257 132 254 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 135.5 255 L 138 255.5 L 135.5 256 L 135.5 255 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 304.5 256 L 311 257.5 L 307.5 258 L 304.5 257 L 304.5 256 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 139.5 257 L 142 257.5 L 139.5 258 L 139.5 257 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 293.5 260 Q 298.9 258.1 298 261.5 Q 296.6 264.3 292 263 L 293.5 260 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 279.5 264 L 282 264.5 L 279.5 265 L 279.5 264 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 286.5 264 L 291 265.5 L 286.5 267 L 283 265.5 L 286.5 264 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 292.5 264 L 295 264.5 L 292.5 265 L 292.5 264 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 272.5 266 L 278 266.5 L 272.5 267 L 272.5 266 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 280.5 266 L 285 267.5 L 282.5 268 L 280.5 266 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 275.5 268 L 276.5 270 L 272 269.5 L 275.5 268 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 251.5 273 L 254 273.5 Q 249.5 277 240.5 276 L 239.5 274 L 250.5 274 L 251.5 273 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 91.5 304 Q 99.8 303.8 103 308.5 Q 106.2 311.8 105 319.5 L 99.5 327 L 89.5 328 L 82 321.5 L 81 315.5 L 82 315.5 L 85 323 L 93.5 325 L 100 321.5 Q 102.5 318 101 310.5 L 97.5 306 Q 88.1 304.1 85 308.5 L 82.5 313 L 82 310.5 Q 85 305.5 91.5 304 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 124.5 304 Q 134.2 302.8 137 308.5 Q 140.2 311.8 139 319.5 L 133.5 327 L 123.5 328 L 117 322.5 L 116 317.5 L 117 317.5 L 117 319.5 L 121.5 324 L 127.5 325 L 135 320.5 L 135 309.5 L 132.5 307 L 122 305.5 L 124.5 304 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 325.5 304 L 330.5 304 L 336 306 Q 339.5 309.8 340 317.5 Q 338.5 324 333.5 327 L 324.5 328 L 317 322.5 L 316 318.5 L 318 319.5 L 320.5 323 L 327.5 325 L 334 321.5 L 334 320 L 336 319.5 L 336 311.5 L 331.5 306 Q 322.1 304.1 319 308.5 L 316.5 314 L 316 311.5 L 320.5 306 L 325.5 304 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 359.5 304 L 364.5 304 L 372 309.5 Q 374.6 312.4 374 318.5 L 367.5 327 Q 364.3 329.3 357.5 328 L 351 322.5 Q 348.5 319 350 311.5 L 354.5 306 L 359.5 304 Z M 357 306 L 354 307 L 351 313 Q 350 319 353 322 L 359 325 L 367 323 L 370 318 L 369 310 Q 367 304 357 306 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 120.5 306 L 119 308.5 L 116.5 314 L 116 311.5 L 120.5 306 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 403.5 322 L 404.5 324 L 402.5 324 L 400.5 325 L 399 324.5 Q 398.2 327.1 401.5 326 L 403 325.5 L 402 327.5 L 403.5 330 L 400 329.5 L 401 327 L 399 327.5 L 399 336 L 395.5 336 L 394 334.5 L 394 324.5 L 395.5 323 Q 401.7 324.8 403.5 322 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 51.5 323 L 53 323.5 L 51 324.5 L 54.5 326 L 57 327.5 L 55 328.5 L 53.5 326 L 52.5 328 L 51.5 326 Q 49.8 329.1 48 327.5 L 47.5 329 L 47 327.5 L 48.5 325 L 49.5 327 L 51.5 323 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 54.5 323 L 62 323 L 62 334.5 Q 61 337 56.5 336 L 56.5 335 Q 59.5 335.7 58 332 Q 54.2 333.5 55 330.5 L 58 329.5 Q 59.3 323.4 56.5 324 Q 54.7 326.5 54.5 323 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 51.5 332 L 52 334 L 50 333.5 L 51.5 332 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 205.5 381 L 251.5 381 L 253 382.5 Q 252 387 254.5 388 L 277.5 388 L 279 389.5 L 279 415.5 Q 276.8 416.8 278 421.5 L 279 424.5 L 277.5 426 L 254.5 426 L 253 427.5 L 254 432.5 L 203.5 433 L 204 431.5 Q 205 427 202.5 426 L 178 426 L 178 388 L 202.5 388 L 203 386.5 L 204.5 387 L 206 387.5 L 204 388.5 L 207 389.5 L 205 390.5 L 208 391.5 L 206.5 395 L 205.5 392 L 205 400.5 L 208.5 411 L 209 398.5 L 206 397.5 L 206 396 L 209 395.5 L 209 387.5 Q 210.2 384.8 211.5 387 Q 216.9 386.4 217 387.5 L 217 422.5 L 218.5 423 L 220 423.5 L 220 422 L 225 422 Q 226.3 425 222.5 424 L 222.5 425 L 231.5 426 L 239 422.5 L 239 392.5 L 238 389 L 240 389.5 L 240 425.5 Q 241 428 245.5 427 L 247 425.5 L 247 388 L 240 387.5 L 244.5 386 L 248 387 L 248.5 411 L 252 398.5 L 252 396.5 Q 250.3 390.2 253 388.5 L 250 383.5 L 252 383.5 Q 252.7 380.5 249 382 L 248.5 384 L 248 382 L 244.5 383 L 243.5 382 L 205.5 382 L 205.5 381 Z M 210 388 L 210 427 L 211 427 L 216 427 L 216 389 L 216 388 L 210 388 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 206.5 383 L 207.5 385 Q 204.7 385.7 206.5 383 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 211.5 384 L 213.5 385 L 215.5 384 L 215.5 385 L 212.5 386 L 211.5 384 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 219.5 384 L 220 387 L 222.5 386 L 224 390.5 L 222 391.5 L 221.5 388 L 220.5 392 Q 221 386.9 218 385.5 L 219.5 384 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 248.5 385 Q 251.1 384.2 250 387.5 L 251 392 L 249 391.5 L 249 389.5 L 248.5 385 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 250.5 393 L 251 395.5 L 250 395.5 L 250.5 393 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 219.5 398 L 220 400.5 L 219 400.5 L 219.5 398 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 223 398 Q 225.7 396.9 225 399.5 L 223 400.5 L 223 398 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 219.5 416 L 222 416.5 L 219.5 417 L 219.5 416 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 233 416 L 235 416.5 L 234 420 L 230.5 422 L 226.5 422 L 227.5 420 Q 232.9 421.9 232 418.5 L 233 416 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 396 434 L 398 434.5 L 398 436.5 L 398 442 L 389.5 442 L 387.5 442 L 68.5 442 L 67.5 443 L 66.5 442 L 59 442 L 59.5 438 L 61.5 439 L 61 437.5 Q 60.3 435.3 62.5 436 L 62.5 438 L 76 437.5 L 72 437 Q 70.8 434 74.5 435 L 79.5 436 Q 80.8 433.7 85.5 435 L 85.5 436 Q 78.6 434 80 438 Q 85.6 439.9 95.5 439 Q 97.2 436.3 103.5 438 Q 105.2 440.7 111.5 439 L 111.5 438 L 107 437.5 Q 114.1 434.6 125.5 436 L 125.5 437 L 112 437.5 L 127.5 439 L 128.5 438 L 144.5 438 L 145.5 439 L 158.5 439 Q 160.3 435.3 167.5 437 L 168.5 438 L 192.5 438 L 194.5 437 L 195.5 438 L 245.5 438 L 246.5 439 L 255.5 437 L 256.5 438 L 264.5 438 L 270.5 438 L 287.5 437 L 296.5 439 L 307.5 439 L 308.5 438 L 319.5 438 Q 321.3 440.7 327.5 439 L 335 437.5 L 311 436.5 L 343.5 436 L 343.5 437 L 336 437.5 L 342.5 439 L 351.5 439 L 352.5 438 L 365.5 438 L 367.5 439 Q 369.3 436.3 375.5 438 L 379.5 439 L 383.5 438 L 385.5 439 L 389.5 438 Q 390.8 440.3 392 437.5 L 393.5 435 L 396.5 439 L 397 436.5 L 396 434 Z M 394 436 Q 392 439 395 438 L 394 436 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 366.5 435 L 367.5 437 L 364 436.5 L 366.5 435 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 370.5 435 L 376 435.5 L 370.5 436 L 370.5 435 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 381.5 435 L 388 436.5 L 384.5 437 L 381.5 436 L 381.5 435 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 88.5 436 L 91 436.5 L 88.5 437 L 88.5 436 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 96.5 436 L 104 436.5 L 96.5 437 L 96.5 436 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 128.5 436 L 136 436.5 L 128.5 437 L 128.5 436 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 347.5 436 L 360 436.5 L 347.5 437 L 347.5 436 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 51 505 L 55.5 506 L 57.5 506 Q 65.5 509.5 76.5 510 L 80.5 512 L 87.5 512 L 99.5 516 L 105.5 516 L 117.5 520 L 123.5 520 L 127.5 522 L 132.5 522 L 145.5 526 L 150.5 526 L 164.5 530 L 169.5 530 L 173.5 532 L 187.5 534 L 196.5 537 L 206.5 538 L 224.5 543 L 232.5 543 L 236.5 541 Q 247.5 541 254.5 537 L 264.5 536 L 268.5 534 L 273.5 534 L 287.5 530 L 292.5 530 L 296.5 528 L 310.5 526 L 324.5 522 L 329.5 522 L 333.5 520 L 338.5 520 L 351.5 516 L 357.5 516 L 369.5 512 L 375.5 512 L 379.5 510 L 384.5 510 L 404.5 505 L 406 506.5 L 408 519 L 398.5 520 L 388.5 523 L 383.5 523 L 370.5 527 L 364.5 527 L 341.5 533 L 335.5 533 L 327.5 536 L 316.5 537 L 312.5 539 L 288.5 543 L 270.5 548 L 263.5 548 L 256.5 551 L 249.5 551 L 241.5 554 L 234.5 554 Q 232.2 556.7 226.5 556 L 222.5 554 L 214.5 554 L 208.5 551 L 201.5 551 L 193.5 548 L 188.5 548 L 179.5 545 L 147.5 539 L 143.5 537 L 133.5 536 L 125.5 533 L 119.5 533 L 111.5 530 L 104.5 530 L 96.5 527 L 91.5 527 L 78.5 523 L 64.5 521 L 49 517 L 51 505 Z M 55 508 Q 52 509 54 511 L 52 511 Q 51 513 54 512 L 53 515 L 55 514 L 58 515 L 57 514 L 59 513 L 56 512 L 57 509 L 55 508 Z M 57 509 L 58 511 L 60 510 L 59 512 L 60 515 L 58 516 L 62 516 L 62 514 Q 64 513 63 517 L 71 519 L 79 517 L 78 516 Q 76 514 75 517 L 73 517 L 77 514 L 80 515 Q 82 516 80 518 L 82 518 L 82 519 L 77 518 L 76 520 L 78 519 L 82 521 L 84 520 L 84 522 L 88 520 L 88 522 L 91 521 L 91 523 L 95 522 L 92 521 Q 94 517 97 522 L 101 520 L 117 525 L 121 525 L 121 526 L 114 525 L 114 527 L 111 528 L 114 528 L 121 529 L 123 528 L 122 530 L 125 530 Q 126 528 128 531 L 129 530 L 126 528 L 126 527 L 132 530 L 129 531 L 133 532 L 135 531 L 134 530 L 134 529 Q 137 528 136 531 L 138 530 L 140 531 L 136 533 L 144 535 L 148 534 L 150 535 L 147 536 L 158 538 L 165 538 L 165 540 L 168 540 L 167 539 L 167 538 L 172 541 L 178 540 L 180 543 L 183 542 L 190 544 L 192 544 L 194 545 L 196 544 L 205 548 L 207 547 L 207 549 L 211 548 L 227 553 L 227 552 L 227 550 L 228 548 L 227 544 L 220 544 L 212 541 L 205 541 L 194 538 L 192 538 L 179 534 L 174 534 L 165 531 L 160 531 L 148 528 L 146 528 L 142 526 L 123 523 L 109 519 L 104 519 L 100 517 Q 87 516 78 512 L 73 512 L 64 509 L 57 509 Z M 101 521 L 97 522 L 99 525 L 103 525 L 99 524 L 102 523 L 101 521 Z M 104 524 L 104 526 L 108 527 Q 111 528 112 526 L 111 524 L 104 524 Z M 196 545 L 195 547 L 199 547 L 196 545 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 66 513 Q 71.5 511.9 74 514.5 L 69 515.5 L 72 516.5 L 68.5 517 L 64 515.5 L 66 515 L 66 513 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 87.5 518 L 91 519.5 L 89.5 520 L 87.5 518 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 156.5 534 L 161 536.5 L 159.5 536 Q 155.7 536.5 156.5 534 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,142,23)",
    stroke: "rgb(222,142,23)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 170.5 538 L 175 539.5 L 172.5 540 L 170.5 538 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(16,39,104)",
    stroke: "rgb(16,39,104)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 64.5 259 L 96.5 269 L 100.5 269 L 103.5 271 L 111.5 272 L 117.5 275 L 122.5 275 L 128.5 278 Q 137.1 278.4 142.5 282 L 146.5 282 L 156.5 286 L 171.5 289 L 190.5 296 L 195.5 296 L 201.5 299 L 206.5 299 L 212.5 302 L 229.5 306 L 236.5 303 L 244.5 302 L 250.5 299 L 255.5 299 L 260.5 296 L 265.5 296 L 271.5 293 L 279.5 292 L 285.5 289 L 289.5 289 L 310.5 282 L 328.5 278 L 334.5 275 L 339.5 275 L 348.5 271 L 350.5 271 L 392.5 259 L 394 260.5 L 394 321.5 L 393 322.5 L 393 334.5 L 394 335.5 L 394 353 L 391.5 354 L 64 354 L 63 351.5 L 63 335.5 L 64 334.5 L 64 323.5 L 63 322.5 L 63 260.5 L 64.5 259 Z M 68 267 L 69 296 L 71 291 L 76 289 L 77 290 L 74 291 L 69 298 L 69 335 L 71 339 L 77 343 L 146 343 L 150 340 L 151 337 L 152 337 L 151 340 L 148 341 L 147 344 L 76 344 L 73 342 L 69 337 L 68 348 L 388 348 L 388 346 L 388 344 L 389 342 L 388 335 L 385 341 L 380 344 L 311 344 L 306 341 L 303 337 L 304 296 L 304 337 L 305 339 L 311 343 L 379 343 L 383 341 L 386 337 L 387 332 Q 388 327 386 326 Q 385 320 387 319 L 386 296 L 384 293 L 379 289 L 312 289 L 308 291 L 305 295 L 304 293 L 307 291 L 308 289 L 286 296 L 271 299 L 254 305 L 247 306 L 240 309 L 235 309 L 229 312 L 222 309 L 218 309 L 211 306 L 207 306 Q 201 302 193 302 L 190 300 L 179 298 L 176 296 L 157 292 L 151 289 L 148 290 L 152 295 L 152 296 L 151 295 L 145 289 L 78 289 L 142 288 L 123 281 L 108 278 L 102 275 L 98 275 L 87 271 L 68 267 Z M 386 267 L 360 275 L 356 275 L 339 281 L 334 281 L 325 285 L 320 285 L 315 288 L 380 288 L 385 291 L 387 299 L 388 299 L 388 268 L 386 267 Z M 388 302 L 387 305 L 388 305 L 388 302 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(16,39,104)",
    stroke: "rgb(16,39,104)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 152.5 298 L 153 333.5 L 152 333.5 L 152.5 298 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(29,67,143)",
    stroke: "rgb(29,67,143)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68 267 L 86.5 271 L 97.5 275 L 101.5 275 L 107.5 278 L 122.5 281 L 142 287.5 L 131.5 288 L 129.5 286 L 122.5 285 L 102.5 278 L 98.5 278 L 90.5 274 L 86.5 274 L 77.5 270 L 74 270 L 74.5 289 L 77.5 288 L 77.5 289 L 71 291 L 68.5 296 L 68 267 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(29,67,143)",
    stroke: "rgb(29,67,143)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 385.5 267 L 388 267.5 L 388 298.5 L 387 298.5 L 385 291 L 379.5 288 L 315 287.5 L 319.5 285 L 324.5 285 L 333.5 281 L 338.5 281 L 355.5 275 L 359.5 275 L 385.5 267 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(29,67,143)",
    stroke: "rgb(29,67,143)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 268 L 99 268.5 L 96.5 269 L 96.5 268 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(29,67,143)",
    stroke: "rgb(29,67,143)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 289 L 156.5 292 L 164.5 293 L 167.5 295 L 175.5 296 L 178.5 298 L 189.5 300 L 206.5 306 L 221.5 309 L 228.5 312 L 234.5 309 L 239.5 309 L 246.5 306 L 253.5 305 L 270.5 299 L 285.5 296 L 307.5 289 L 306.5 291 L 304 292.5 L 303 296.5 L 303 336.5 L 305.5 341 L 310.5 344 L 379.5 344 L 385 340.5 L 387.5 335 L 389 341.5 L 388 343.5 L 388 345.5 L 387.5 348 L 68 348 L 68.5 337 L 72.5 342 L 75.5 344 L 146.5 344 L 148 341 L 151 339.5 L 152.5 334 L 153 337.5 L 150 341.5 L 152.5 343 L 156.5 342 L 158.5 343 L 159.5 342 L 223.5 342 L 226.5 343 L 228 342.5 L 228 317 L 204.5 309 L 200.5 309 Q 195.8 305.2 187.5 305 L 172.5 299 L 168.5 299 Q 161 294.8 151 294 L 148.5 289 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(29,67,143)",
    stroke: "rgb(29,67,143)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 302 L 388 304.5 L 387 304.5 L 387.5 302 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,87,168)",
    stroke: "rgb(40,87,168)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74 270 L 77.5 270 L 86.5 274 L 90.5 274 L 98.5 278 L 113.5 281 L 131 287.5 L 75.5 288 L 74.5 289 L 74 270 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,87,168)",
    stroke: "rgb(40,87,168)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152 294 L 161.5 296 L 164.5 298 L 172.5 299 L 187.5 305 Q 195.8 305.2 200.5 309 L 204.5 309 L 228 317 L 228 342.5 L 226.5 343 L 223.5 342 L 159.5 342 L 157.5 343 L 153.5 342 L 151.5 342 L 150 341.5 L 153 337.5 L 153 296.5 L 152 294 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 205.5 38 Q 212.8 37.2 215 41.5 L 216 47.5 L 214 48.5 L 215 44.5 L 211.5 40 L 205.5 39 L 204 39.5 L 205.5 38 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 246.5 38 L 251.5 38 L 256 42.5 L 254 43 L 252.5 40 L 246.5 39 L 242 42.5 Q 240.2 49.3 243.5 51 L 249.5 53 L 254 51 L 255.5 44 L 256 49.5 L 251.5 54 L 246.5 54 L 241 49.5 L 240 46.5 L 242 40 L 246.5 38 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 202.5 40 L 203 41.5 Q 200 42.5 201 47.5 L 204.5 52 L 208.5 53 L 211.5 51 L 213 51.5 L 213.5 50 L 214 51.5 Q 212 55 205.5 54 L 201 50.5 L 200 42.5 L 202.5 40 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 273.5 47 L 274 64.5 L 272.5 66 L 183 66 L 183.5 64 L 184.5 65 L 273 65 L 273.5 47 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 152.5 54 L 155 54.5 L 152.5 55 L 152.5 54 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 180.5 54 L 181 69 L 274.5 69 L 275 68.5 L 275 55.5 Q 276.3 52.7 277.5 55 L 359.5 72 Q 368.2 74.8 373 81.5 L 375 85.5 Q 374 88 369.5 87 L 367.5 87 L 312.5 87 L 311.5 86 L 310.5 87 L 82 87 Q 82.4 81.2 86.5 78 L 100.5 71 L 102.5 71 L 113.5 68 L 119.5 68 L 128.5 65 L 134.5 65 L 145.5 61 L 147.5 62 L 180.5 54 Z M 163 64 L 163 65 L 165 65 L 163 64 Z M 156 65 L 125 72 L 119 72 Q 113 76 105 76 L 100 79 L 97 79 L 91 83 L 91 84 L 325 84 L 288 83 L 282 83 L 281 82 L 233 82 L 232 81 L 194 81 L 193 80 L 162 80 L 161 79 L 119 79 L 118 77 L 160 66 L 156 65 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 314.5 57 L 317 57.5 L 314.5 58 L 314.5 57 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 203.5 58 L 206 59.5 L 204.5 60 L 203.5 58 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 253.5 58 L 252.5 60 L 249 59.5 L 253.5 58 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 208.5 59 L 212 59.5 L 208.5 60 L 208.5 59 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 244.5 59 L 247 59.5 L 244.5 60 L 244.5 59 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 78.5 73 L 77.5 75 L 78.5 73 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 65.5 89 L 70 89.5 L 65.5 90 L 65.5 89 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 224.5 89 L 229 89.5 L 224.5 90 L 224.5 89 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 386.5 89 L 392 89.5 L 386.5 90 L 386.5 89 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 86.5 106 L 83.5 110 L 86.5 106 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 369.5 107 L 370.5 109 L 369.5 107 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 358.5 110 L 361 111.5 L 359.5 111 L 358.5 110 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 252.5 112 L 249.5 116 L 252.5 112 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 364.5 114 L 366.5 117 L 364.5 114 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 205.5 116 L 206.5 118 L 205.5 116 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 246.5 122 L 247 126.5 L 246 126.5 L 246.5 122 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 368.5 123 L 369 207.5 L 368 207.5 L 368.5 123 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 85.5 124 L 86 200.5 L 85 200.5 L 85.5 124 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62.5 125 L 63 245.5 L 62 245.5 L 62.5 125 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 54.5 128 L 55 322 L 58 322.5 L 54 323 L 54.5 128 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 246.5 128 L 247 207.5 L 246 207.5 L 246.5 128 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 402.5 136 L 403 247.5 L 402 247.5 L 402.5 136 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 207.5 208 L 208 210.5 L 207 210.5 L 207.5 208 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 88.5 214 L 92.5 219 L 88.5 214 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 205.5 214 L 204.5 216 L 205.5 214 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 364.5 216 L 363.5 218 L 364.5 216 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 82.5 220 L 83.5 222 L 82.5 220 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 244.5 221 L 246.5 224 L 244.5 221 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 94.5 226 L 200 226.5 L 94.5 227 L 94.5 226 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 254.5 226 L 361 226.5 L 254.5 227 L 254.5 226 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62.5 258 L 63.5 260 L 62.5 258 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 77.5 289 L 145 289.5 L 77.5 290 L 77.5 289 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 311.5 289 L 379 289.5 L 311.5 290 L 311.5 289 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 307.5 291 L 305.5 294 L 307.5 291 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 79.5 294 L 81 294.5 L 77.5 296 L 77.5 295 L 79.5 294 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 313.5 294 L 315 294.5 L 309 298.5 L 308.5 300 L 308 298.5 L 313.5 294 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 375.5 294 L 381 297.5 L 378.5 296 Q 374.7 295.8 375.5 294 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 143.5 295 L 147 297.5 L 145 298 Q 146.1 295.3 143.5 296 L 143.5 295 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 69.5 297 L 70 300.5 L 69 300.5 L 69.5 297 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 75.5 297 L 75 298.5 L 74.5 300 L 74 298.5 L 75.5 297 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 147.5 299 L 148 302.5 L 147 302.5 L 147.5 299 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 69.5 302 L 70 334.5 L 69 334.5 L 69.5 302 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 147.5 304 L 148 327.5 L 147 327.5 L 147.5 304 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 386.5 305 L 387 318.5 L 386 318.5 L 386.5 305 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 398.5 322 L 401 322.5 L 398.5 323 L 398.5 322 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 63.5 324 L 64 334.5 L 63 334.5 L 63.5 324 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 386.5 326 L 387 331.5 L 386 331.5 L 386.5 326 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 147.5 329 L 148 332.5 L 147 332.5 L 147.5 329 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 74.5 331 L 77 336.5 L 75 335.5 L 74.5 331 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 381.5 332 L 382 333.5 L 380 334.5 L 381.5 332 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 308.5 333 L 314 337.5 L 312.5 338 L 308.5 333 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 146.5 334 L 143.5 338 L 142 337.5 L 146.5 334 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 378.5 336 L 377.5 338 L 378.5 336 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 82.5 338 L 139 338.5 L 82.5 339 L 82.5 338 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 305.5 338 L 306.5 340 L 305.5 338 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 317.5 338 L 374 338.5 L 317.5 339 L 317.5 338 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 384.5 338 L 383.5 340 L 384.5 338 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 146.5 341 L 145.5 343 L 144 342.5 L 146.5 341 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 76.5 342 L 79 342.5 L 76.5 343 L 76.5 342 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 376.5 342 L 379 342.5 L 376.5 343 L 376.5 342 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 63.5 352 L 64 354 L 391.5 354 L 394 353 L 394.5 355 L 395.5 354 L 405 354 L 405 392 L 309.5 392 L 308 390.5 L 308 384.5 L 306 380.5 L 304 365.5 L 302 360 L 298.5 361 L 296.5 360 L 295.5 361 L 160.5 361 L 157.5 360 L 154 361.5 L 151 378.5 L 147 392 L 52 392 L 52 354 L 61.5 354 L 63.5 352 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 158 366 L 298.5 366 L 299 369.5 L 302 379.5 L 302 385.5 L 305 392.5 L 305 399.5 L 307.5 404 L 308.5 403 L 393 403 L 392.5 405 L 391.5 404 L 312.5 404 L 310.5 404 L 308 405.5 Q 310.3 406.8 307.5 408 Q 301.6 410.1 303 405.5 L 296 371 L 161.5 371 L 161 372.5 L 158 380.5 L 158 388.5 L 155 396.5 L 154 408 Q 148.6 409.5 147 406.5 Q 149.3 405.3 146.5 404 L 144.5 404 L 62 403.5 L 151 403 L 151 397.5 L 158 366 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 45.5 393 L 46 397.5 L 45 397.5 L 45.5 393 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 210.5 395 L 211 413.5 L 210 413.5 L 210.5 395 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 148 413 L 176.5 413 L 177 418 L 149.5 418 L 148 416.5 L 148 413 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 279 413 L 307.5 413 L 308 418 L 279.5 418 L 279 413 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 246.5 421 L 247 423.5 L 246 423.5 L 246.5 421 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 254 427 L 272.5 427 L 273 429 L 254.5 429 L 254 427 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 274.5 427 Q 279.3 425.7 278 429 Q 273.8 429.1 274.5 427 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 69.5 443 L 387.5 443 L 388 446.5 L 390 450.5 L 390 456.5 L 393 467.5 L 395 484.5 L 399 502.5 L 397.5 506 L 376.5 511 L 371.5 511 L 358.5 515 L 344.5 517 L 340.5 519 L 316.5 523 L 308.5 526 L 301.5 526 L 293.5 529 L 270.5 533 L 261.5 536 L 256.5 536 L 243.5 540 L 232.5 541 L 227.5 543 L 223.5 541 L 213.5 540 L 200.5 536 L 194.5 536 L 186.5 533 L 176.5 532 L 172.5 530 Q 161.5 530 154.5 526 L 148.5 526 L 140.5 523 Q 129.2 522.8 121.5 519 L 115.5 519 L 111.5 517 Q 96.9 515.6 85.5 511 L 79.5 511 L 75.5 509 Q 65.1 508.6 58 506 L 58 495.5 L 60 492.5 L 62 476.5 L 65 464.5 L 65 462.5 L 67 454.5 L 67 448.5 L 69.5 443 Z M 78 444 L 73 445 L 71 460 L 68 470 L 67 482 L 64 491 L 64 499 L 62 502 L 64 504 Q 67 505 65 501 L 67 502 L 66 506 L 71 505 L 81 508 L 87 508 L 88 511 L 92 510 Q 94 504 89 506 L 87 507 Q 88 504 92 505 Q 94 506 93 510 L 108 513 L 111 509 L 113 510 Q 115 509 114 513 L 114 515 L 129 518 Q 131 517 130 520 L 135 520 L 135 517 L 132 515 L 130 516 L 134 514 Q 137 515 136 520 Q 142 519 145 522 Q 151 523 151 521 Q 152 518 156 519 L 157 521 L 152 520 Q 151 524 154 525 L 157 523 L 164 526 Q 169 525 171 527 L 173 526 L 175 530 L 178 529 Q 179 525 177 524 L 175 525 L 173 525 L 177 523 Q 180 524 179 529 L 192 531 L 193 532 L 197 528 L 198 529 L 197 529 Q 192 532 197 534 L 200 533 L 215 536 L 217 536 L 228 539 L 228 445 L 81 445 L 78 444 Z M 240 455 L 238 457 L 238 520 L 238 522 L 240 524 L 259 521 L 258 492 L 257 491 L 257 475 L 256 474 L 256 455 L 240 455 Z M 276 455 L 274 457 L 275 472 L 276 473 L 276 483 L 277 484 L 277 503 L 278 504 Q 277 512 279 517 L 296 515 L 299 513 L 298 512 L 298 500 L 295 483 L 295 473 L 294 472 L 293 457 L 292 455 L 276 455 Z M 313 455 L 311 457 L 318 510 L 331 509 L 338 507 L 333 480 L 332 468 L 329 458 L 329 455 L 313 455 Z M 350 455 L 348 457 L 357 503 L 375 501 L 376 500 L 375 492 L 371 480 L 371 475 L 367 462 L 367 457 L 366 455 L 350 455 Z M 388 501 L 386 505 Q 387 507 391 506 L 392 503 Q 391 500 388 501 Z M 367 505 L 364 508 L 365 510 L 369 511 Q 371 510 370 507 L 367 505 Z M 111 510 Q 108 511 109 515 L 112 516 Q 115 517 113 512 L 111 510 Z M 345 510 L 343 512 L 344 516 L 348 515 L 349 513 Q 349 510 345 510 Z M 322 515 L 322 519 L 326 520 L 327 517 Q 326 514 322 515 Z M 303 519 Q 300 520 301 524 L 304 525 L 306 522 L 303 519 Z M 281 524 Q 278 525 279 529 L 283 530 Q 285 529 284 526 L 281 524 Z M 259 529 L 257 533 L 260 534 L 263 533 L 262 531 Q 263 528 259 529 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 90.5 455 L 108.5 455 L 109 458.5 L 108 458.5 L 107.5 456 L 90 456 L 89.5 460 L 89 456.5 L 90.5 455 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 127.5 455 L 145.5 455 L 146 456.5 L 144.5 456 L 127.5 456 L 127.5 455 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 164.5 455 L 182.5 455 Q 183.6 455.1 183 460.5 L 182 460.5 Q 182.5 456 181.5 456 L 164 456 L 163.5 461 L 163 456.5 L 164.5 455 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 200 455 L 218.5 455 L 220 456.5 L 219.5 460 L 219 456 L 201 456 L 201 463.5 L 200 463.5 L 200 455 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 126.5 459 L 127 461.5 L 126 461.5 L 126.5 459 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 88.5 462 L 89 465.5 L 88 465.5 L 88.5 462 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 144.5 462 L 145 468.5 L 144 468.5 L 144.5 462 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 125.5 463 L 126 466.5 L 125 466.5 L 125.5 463 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 162.5 464 L 163 468.5 L 162 468.5 L 162.5 464 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 106.5 466 L 107 468.5 L 106 468.5 L 106.5 466 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 181.5 466 L 182 471.5 L 181 471.5 L 181.5 466 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 87.5 467 L 88 469.5 L 85.5 478 L 85 474.5 L 87.5 467 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 143.5 470 L 144 473.5 L 143 473.5 L 143.5 470 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 105.5 472 L 106 474.5 L 105 474.5 L 105.5 472 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 123.5 474 L 124 479.5 L 123 479.5 L 123.5 474 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 161.5 474 L 162 482.5 L 161 482.5 L 161.5 474 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 104.5 477 L 105 479.5 L 104 479.5 L 104.5 477 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 142.5 477 L 143 479.5 L 142 479.5 L 142.5 477 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 180.5 477 L 181 484.5 L 180 484.5 L 180.5 477 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 199.5 480 L 200 488.5 L 199 488.5 L 199.5 480 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 218.5 480 L 219 507.5 L 218 507.5 L 218.5 480 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 122.5 482 L 123 484.5 L 122 484.5 L 122.5 482 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 141.5 483 L 142 489.5 L 141 489.5 L 141.5 483 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 83.5 484 L 84 486.5 L 83 486.5 L 83.5 484 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 160.5 486 L 161 489.5 L 160 489.5 L 160.5 486 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 102.5 487 L 103 490.5 L 102 490.5 L 102.5 487 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 121.5 487 L 122 489.5 L 121 489.5 L 121.5 487 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 82.5 488 L 83 490.5 L 82 490.5 L 82.5 488 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 179.5 488 L 180 499.5 L 179 499.5 L 179.5 488 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 101.5 492 L 102 495.5 L 101 495.5 L 101.5 492 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 81.5 493 L 82 495.5 L 81 495.5 L 81.5 493 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 140.5 493 L 141 497.5 L 140 497.5 L 140.5 493 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 159.5 494 L 160 498.5 L 159 498.5 L 159.5 494 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 80.5 498 L 81 500 L 83 500.5 L 81.5 501 L 80.5 498 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 198.5 498 L 199 509.5 L 198 509.5 L 198.5 498 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 119.5 499 L 120 504.5 L 119 507 L 123 507.5 L 119.5 508 L 118 505.5 L 119.5 499 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 139.5 500 L 140 502.5 L 139 502.5 L 139.5 500 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 158.5 500 L 159 508.5 L 158 508.5 L 158.5 500 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 70.5 501 L 71.5 503 L 70.5 501 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 86.5 501 L 90 501.5 L 86.5 502 L 86.5 501 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 93.5 502 L 96 502.5 L 93.5 503 L 93.5 502 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 99.5 502 L 98.5 504 L 97 503.5 L 99.5 502 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 138.5 506 L 139 509.5 L 137 510.5 L 138.5 506 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 124.5 508 L 127 508.5 L 124.5 509 L 124.5 508 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 178.5 508 L 179 511.5 L 178 511.5 L 178.5 508 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 130.5 509 L 135 509.5 L 130.5 510 L 130.5 509 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 158.5 514 L 162 514.5 L 158.5 515 L 158.5 514 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 163.5 515 L 168 515.5 L 163.5 516 L 163.5 515 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 197.5 515 L 198 521 L 201 521.5 L 198.5 522 Q 195.4 520.4 197.5 515 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 203.5 522 L 208 522.5 L 203.5 523 L 203.5 522 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 211.5 523 L 214 523.5 L 211.5 524 L 211.5 523 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,34,34)",
    stroke: "rgb(35,34,34)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 215.5 524 L 218 524.5 L 215.5 525 L 215.5 524 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 206.5 32 Q 216.6 31.9 220 38.5 L 222 44.5 L 222 49.5 L 220 55 Q 217 53.8 218 57.5 L 217.5 59 L 231.5 60 L 240 58.5 L 234 48.5 L 234 46.5 L 235 40.5 L 239.5 35 L 242.5 33 L 249.5 32 L 254.5 33 L 260 37.5 L 263 46.5 L 262 48.5 L 267 44.5 L 272.5 34 L 273 65 L 184.5 65 L 183 63.5 L 183 35.5 L 184.5 34 L 190 46 Q 192.7 44.9 192 47.5 L 194 48.5 Q 192.9 39.5 197.5 36 L 201.5 33 L 206.5 32 Z M 206 38 L 206 39 L 210 39 L 206 38 Z M 247 38 Q 246 40 251 39 L 251 40 L 245 39 L 245 41 Q 243 45 242 42 L 240 47 L 241 50 L 243 49 Q 245 50 243 52 Q 245 55 252 54 Q 256 52 253 51 L 255 51 Q 257 50 256 45 L 256 43 Q 255 40 254 42 Q 251 41 253 40 Q 252 37 247 38 Z M 205 39 L 204 41 Q 202 39 200 43 L 201 51 L 206 54 L 213 53 L 212 52 L 213 50 L 214 52 L 214 50 L 214 48 L 215 42 L 212 39 L 210 40 L 205 39 Z M 242 40 L 242 42 L 244 41 L 242 40 Z M 216 44 L 215 48 L 216 48 L 216 44 Z M 209 59 L 209 60 L 212 60 L 209 59 Z M 245 59 L 245 60 L 247 60 L 245 59 Z M 250 59 L 250 60 L 253 60 L 250 59 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 275.5 47 L 278 47.5 L 275.5 48 L 275.5 47 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 168.5 50 L 171 50.5 L 168.5 51 L 168.5 50 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 286.5 50 L 289 50.5 L 286.5 51 L 286.5 50 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 162.5 64 L 165 64.5 L 162.5 65 L 162.5 64 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 155.5 65 L 160 65.5 L 118 77 L 118.5 79 L 160.5 79 L 161.5 80 L 192.5 80 L 193.5 81 L 231.5 81 L 232.5 82 L 280.5 82 L 281.5 83 L 287.5 83 L 325 83.5 L 90.5 84 L 90.5 83 L 96.5 79 L 99.5 79 L 104.5 76 Q 113.1 75.6 118.5 72 L 124.5 72 L 155.5 65 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 382.5 75 L 384.5 78 L 382.5 75 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 70.5 89 L 224 89.5 L 70.5 90 L 70.5 89 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 232.5 89 L 386 89.5 L 232.5 90 L 232.5 89 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 94.5 103 L 200 103.5 L 94.5 104 L 94.5 103 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 254.5 103 L 361 103.5 L 254.5 104 L 254.5 103 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 246.5 106 L 242.5 111 L 246.5 106 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 371.5 109 L 372.5 111 L 371.5 109 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 96.5 110 L 100 110.5 L 96.5 111 L 96.5 110 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 195.5 110 L 198 110.5 L 195.5 111 L 195.5 110 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 256.5 110 L 261 110.5 L 255.5 112 L 256.5 110 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 355.5 110 L 358 110.5 L 355.5 111 L 355.5 110 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 199.5 111 L 200.5 113 L 199.5 111 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 253.5 112 L 252.5 114 L 253.5 112 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 361.5 112 L 364 113.5 L 362.5 114 L 361.5 112 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 91.5 113 L 89.5 116 L 91.5 113 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 202.5 113 L 204.5 116 L 202.5 113 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 365.5 116 L 366.5 118 L 365.5 116 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 88.5 117 L 88 118.5 L 87.5 120 L 87 118.5 L 88.5 117 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 214.5 118 L 215 211.5 L 214 211.5 L 214.5 118 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 207.5 122 L 208 207.5 L 207 207.5 L 207.5 122 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 239.5 128 L 240 209.5 L 239 209.5 L 239.5 128 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 367.5 208 L 368 210.5 L 367 210.5 L 367.5 208 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 366.5 213 L 364.5 216 L 366.5 213 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 249.5 214 L 252.5 218 L 249.5 214 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 203.5 216 L 202.5 218 L 203.5 216 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 213.5 217 L 212.5 219 L 213.5 217 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 93.5 218 L 96 219.5 L 94.5 219 L 93.5 218 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 373.5 218 L 372.5 220 L 373.5 218 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 99.5 220 L 195 220.5 L 99.5 221 L 99.5 220 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 260.5 220 L 356 220.5 L 260.5 221 L 260.5 220 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 210.5 221 L 208.5 224 L 210.5 221 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 84.5 222 L 85.5 224 L 84.5 222 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 247.5 224 L 250 225.5 L 248.5 226 L 247.5 224 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 367.5 224 L 366.5 226 L 367.5 224 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62.5 246 L 63 257.5 L 62 257.5 L 62.5 246 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 81.5 294 L 86 294.5 Q 80.4 294.4 79 298.5 L 79 328.5 L 80.5 330 L 82 330 L 82.5 332 L 93.5 332 L 95.5 333 L 97.5 332 L 102.5 333 L 104.5 332 L 106.5 333 L 108.5 332 L 111.5 333 L 114.5 332 Q 116 334.5 121.5 333 L 125.5 331 L 126 333 L 134.5 332 L 136.5 332 Q 140.5 332.5 141 329.5 L 143 323.5 L 143 317.5 L 141.5 315 Q 141.8 323.8 136.5 327 L 128.5 330 Q 127 327.5 121.5 329 L 116 324.5 L 115 316 Q 112.3 317.1 113 314.5 L 119.5 305 Q 122.7 301.2 131.5 303 L 134 304 L 133.5 306 Q 131.2 302.8 124.5 304 L 117 309.5 Q 114.5 313 116 320.5 L 121.5 327 L 130.5 328 L 137 323.5 Q 140.2 320.2 139 312.5 L 135 305.5 L 137.5 307 Q 140.1 306.2 139 309.5 L 142.5 315 L 143 299.5 L 141 296 L 138.5 295 L 88 294.5 L 139.5 294 L 145 296 Q 144 299 147 298 L 147 302.5 L 147 304.5 L 147 327.5 L 148 328.5 L 147 333.5 L 143.5 337 L 141.5 338 L 79.5 338 L 76 335.5 L 74 330.5 L 74 300.5 L 76 296 L 81.5 294 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 315.5 294 L 374.5 294 L 381 298.5 L 382 300.5 L 382 331.5 L 380 336 L 376.5 338 L 314.5 338 L 308 332.5 L 308 300.5 L 311.5 296 L 315.5 294 Z M 318 295 L 315 296 L 313 300 L 313 327 L 314 329 Q 316 333 323 333 L 325 333 Q 329 334 331 332 L 335 333 Q 340 335 342 332 L 345 333 Q 351 335 353 332 L 355 333 L 367 332 L 369 332 L 374 332 Q 373 329 376 330 L 377 328 L 377 300 L 376 298 L 374 295 L 318 295 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 88.5 303 Q 101.4 301.1 105 308.5 L 107 313.5 L 107 319.5 L 101.5 328 Q 98.5 331 91.5 330 Q 84.3 328.2 81 322.5 L 80 315.5 L 81 315.5 Q 81 324.5 87.5 327 L 96.5 328 L 103 323.5 Q 106.2 320.2 105 312.5 L 99.5 305 L 91.5 304 Q 85 305.5 82 310.5 Q 83.3 315.3 80 314 L 81 309 Q 83.7 310.1 83 307.5 L 88.5 303 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 322 303 Q 335.8 300.8 340 309.5 L 341 320.5 L 337 326.5 L 337.5 328 L 335.5 328 Q 332.8 330.8 326.5 330 L 317 326 L 314 319.5 L 314 315.5 L 315 310.5 L 319.5 305 Q 323.3 306 322 303 Z M 326 304 L 321 306 Q 316 309 315 316 L 317 323 L 325 328 L 334 327 Q 338 324 340 318 Q 340 310 336 306 L 331 304 L 326 304 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 357.5 303 L 366.5 303 L 372 306 Q 376.5 310.8 375 322.5 L 373 326 L 364.5 330 L 359.5 330 Q 351.6 328.9 349 322.5 Q 350.2 317.8 348 316.5 Q 350.2 315.2 349 310.5 L 352 306 L 357.5 303 Z M 360 304 L 355 306 L 350 312 Q 349 319 351 323 L 358 328 Q 364 329 368 327 L 374 319 Q 375 312 372 310 L 365 304 L 360 304 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 106 304 L 108 304.5 L 106 305.5 L 106 304 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62 323 L 64 323.5 L 63 324.5 L 63 336 L 61 335.5 L 62 334.5 L 62 323 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 393 323 L 395 323.5 L 394 324.5 L 393.5 335 L 393 323 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 46.5 353 L 60 353.5 L 46.5 354 L 46.5 353 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 45.5 358 L 46 392.5 L 45 392.5 L 45.5 358 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 161 371 L 295.5 371 L 296 373.5 L 298 378.5 L 299 389.5 L 301 394.5 L 301 399.5 L 303 408 Q 307.6 409.3 309 406.5 Q 306.8 405.3 309.5 404 L 311.5 405 L 312.5 404 L 391.5 404 L 394 404.5 L 394 432.5 L 393.5 433 L 254.5 433 Q 252 432 253 427.5 L 254.5 426 L 277.5 426 L 279 424.5 L 278 416.5 L 279 416.5 L 279.5 418 L 308 418 L 307.5 413 L 279 413 L 279 388 L 254.5 388 Q 251.5 386.4 253 381 L 204.5 381 Q 203.5 381 204 385.5 L 203 388 L 178 388 L 178 426 L 202.5 426 L 204 427.5 Q 205 432 202.5 433 L 63.5 433 L 63 432.5 L 63 404 L 144.5 404 L 145.5 405 Q 146.8 402.8 148 405.5 Q 145.8 406.8 148.5 408 Q 155.8 410.6 154 404.5 Q 156.8 402.8 155 396.5 L 158 388.5 L 158 380.5 L 161 371 Z M 148 413 L 148 417 L 150 418 L 177 418 L 177 413 L 148 413 Z M 254 427 L 255 429 L 273 429 L 273 427 L 254 427 Z M 275 427 Q 274 429 278 429 Q 279 426 275 427 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 240.5 388 L 241 426 L 246 426.5 L 241.5 427 L 240 425.5 L 240.5 388 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 246.5 388 L 247 418.5 L 246 418.5 L 246.5 388 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 210.5 426 L 216 426.5 L 210.5 427 L 210.5 426 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 68 442 L 388 442.5 L 69.5 443 L 68.5 444 L 68 442 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 77.5 444 L 80.5 445 L 228 445 L 228 539 L 216.5 536 L 214.5 536 L 200 533 L 200 529 L 198.5 529 L 196.5 528 L 192.5 532 L 191.5 531 L 179 529 Q 180 524.3 176.5 523 L 173 524 L 171.5 527 L 157 524 Q 158 520.2 155.5 519 Q 151.8 518.3 151 520.5 Q 151.5 523.5 144.5 522 Q 142 518.8 136 520 Q 137 515.3 133.5 514 L 130 515.5 Q 131.1 518.8 128.5 518 L 114 514.5 L 114 512.5 Q 115.1 509.2 112.5 510 L 110.5 509 L 108 513 L 93 510 Q 94 506.2 91.5 505 Q 87.8 504.3 87 506.5 Q 87.5 509.5 80.5 508 L 71 505 L 72 502.5 Q 70.4 499.5 65 501 Q 66.5 504.7 63.5 504 L 62 501.5 L 64 498.5 L 64 490.5 L 67 481.5 L 68 469.5 L 71 459.5 L 73 445 L 77.5 444 Z M 78 448 L 76 450 L 75 460 Q 71 467 71 478 L 69 482 L 70 486 L 80 453 L 200 449 L 78 448 Z M 91 455 L 89 457 L 88 467 L 85 475 L 85 481 L 83 485 L 80 500 L 84 501 L 86 501 L 99 504 L 102 496 L 103 484 L 105 480 L 107 464 L 109 459 L 109 455 L 91 455 Z M 127 455 L 118 507 L 120 508 L 137 510 L 138 511 L 139 510 L 139 504 L 141 498 L 142 481 L 145 469 L 145 458 L 146 457 L 146 455 L 127 455 Z M 165 455 L 163 457 L 162 474 L 161 475 L 161 486 L 158 501 L 158 512 L 157 513 L 158 515 L 172 516 L 178 518 L 179 512 L 179 501 L 180 500 L 181 473 L 182 472 L 182 462 L 183 461 Q 184 455 183 455 L 165 455 Z M 200 455 L 200 480 L 199 481 L 199 498 L 198 499 L 197 521 L 199 522 L 211 523 L 218 525 L 218 509 L 219 508 L 219 461 L 220 457 L 219 455 L 200 455 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 66.5 452 L 67 454.5 L 66 454.5 L 66.5 452 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 390.5 453 L 391 456.5 L 390 456.5 L 390.5 453 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 63.5 468 L 64 471.5 L 63 471.5 L 63.5 468 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 61.5 480 L 62 482.5 L 61 482.5 L 61.5 480 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 57.5 500 L 58 505.5 L 57 505.5 L 57.5 500 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 399.5 504 L 400 506 L 398 505.5 L 399.5 504 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 67.5 508 L 71 508.5 L 67.5 509 L 67.5 508 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 385.5 508 L 390 508.5 L 381.5 510 L 381.5 509 L 385.5 508 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 73.5 509 L 76 509.5 L 73.5 510 L 73.5 509 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 80.5 511 L 86 511.5 L 80.5 512 L 80.5 511 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 371.5 511 L 376 511.5 L 371.5 512 L 371.5 511 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 91.5 513 L 94 513.5 L 91.5 514 L 91.5 513 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 95.5 514 L 98 514.5 L 95.5 515 L 95.5 514 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 99.5 515 L 103 515.5 L 99.5 516 L 99.5 515 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 353.5 515 L 358 515.5 L 353.5 516 L 353.5 515 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 109.5 517 L 112 517.5 L 109.5 518 L 109.5 517 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 344.5 517 L 347 517.5 L 344.5 518 L 344.5 517 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 117.5 519 L 122 519.5 L 117.5 520 L 117.5 519 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 336.5 519 L 339 519.5 L 336.5 520 L 336.5 519 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 330.5 520 L 333 520.5 L 326.5 522 L 326.5 521 L 330.5 520 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 127.5 521 L 130 521.5 L 127.5 522 L 127.5 521 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 133.5 522 L 136 522.5 L 133.5 523 L 133.5 522 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 321.5 522 L 324 522.5 L 321.5 523 L 321.5 522 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 137.5 523 L 141 523.5 L 137.5 524 L 137.5 523 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 316.5 523 L 319 523.5 L 316.5 524 L 316.5 523 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 312.5 524 L 315 524.5 L 312.5 525 L 312.5 524 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 145.5 525 L 148 525.5 L 145.5 526 L 145.5 525 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 151.5 526 L 158 527.5 L 155.5 528 L 151.5 527 L 151.5 526 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 301.5 526 L 305 526.5 L 298.5 528 L 298.5 527 L 301.5 526 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 164.5 529 L 168 529.5 L 164.5 530 L 164.5 529 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 289.5 529 L 293 529.5 L 289.5 530 L 289.5 529 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 170.5 530 L 176 531.5 L 173.5 532 L 170.5 531 L 170.5 530 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 284.5 530 L 287 530.5 L 284.5 531 L 284.5 530 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 280.5 531 L 283 531.5 L 280.5 532 L 280.5 531 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 178.5 532 L 182 532.5 L 178.5 533 L 178.5 532 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 275.5 532 L 278 532.5 L 275.5 533 L 275.5 532 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 183.5 533 L 187 533.5 L 183.5 534 L 183.5 533 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 270.5 533 L 274 533.5 L 270.5 534 L 270.5 533 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 262.5 535 L 265 535.5 L 262.5 536 L 262.5 535 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 196.5 536 L 201 536.5 L 196.5 537 L 196.5 536 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 256.5 536 L 260 536.5 L 256.5 537 L 256.5 536 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 202.5 537 L 205 537.5 L 202.5 538 L 202.5 537 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 210.5 539 L 213 539.5 L 210.5 540 L 210.5 539 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 244.5 539 L 247 539.5 L 244.5 540 L 244.5 539 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 215.5 540 L 218 540.5 L 215.5 541 L 215.5 540 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 238.5 540 L 242 540.5 L 238.5 541 L 238.5 540 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 220.5 541 L 227 542.5 L 224.5 543 L 220.5 542 L 220.5 541 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(75,72,67)",
    stroke: "rgb(75,72,67)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 232.5 541 L 236 541.5 L 230.5 543 L 230.5 542 L 232.5 541 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 274.5 47 L 280.5 50 L 282.5 49 L 288.5 52 L 290.5 51 L 299.5 55 L 301.5 55 L 303.5 54 L 307.5 56 L 309 55.5 L 309.5 57 L 311.5 57 L 322.5 60 L 324.5 60 L 328.5 62 L 330 61.5 Q 329.3 63.8 331.5 63 L 331.5 61 L 335.5 63 L 342.5 64 L 344.5 66 L 348.5 66 L 350.5 67 L 352.5 66 L 359.5 69 L 361.5 69 L 363.5 70 Q 364.8 67.8 366 70.5 L 365.5 72 L 368.5 70 L 369.5 72 L 371.5 72 L 373.5 73 L 375.5 73 Q 378.8 71.9 378 74.5 L 380.5 77 L 382.5 77 L 385.5 79 L 388 80 L 390 84.5 L 388 85.5 L 392 88.5 L 389.5 89 L 387.5 89 L 69.5 89 L 68.5 88 L 65 88.5 L 69 80 Q 71.7 81.1 71 78.5 L 73.5 76 L 77 76.5 L 78.5 74 L 86.5 71 L 88.5 71 L 98.5 68 L 100.5 69 L 100.5 67 Q 102 69.5 103.5 66 L 105.5 67 L 110 65 L 110.5 67 L 111 65 L 113.5 64 L 116 64.5 L 116.5 66 L 117.5 63 L 119.5 63 L 122.5 62 L 124 62.5 Q 123.2 59.9 126.5 61 L 128.5 61 L 133.5 59 L 136 60 Q 134.9 57.3 137.5 58 L 139.5 59 L 144.5 57 L 145.5 58 L 148.5 55 L 150.5 56 L 152.5 55 L 153.5 56 L 158.5 53 L 161.5 52 Q 163 54.5 164.5 51 L 171 52 Q 169.9 49.3 172.5 50 L 175.5 49 L 183 48 L 183 65.5 L 183.5 66 L 272.5 66 L 274 64.5 L 274.5 47 Z M 181 54 L 148 62 L 146 61 L 143 63 L 140 62 L 139 64 L 129 65 L 113 69 L 111 68 L 109 70 L 102 72 L 101 70 L 100 72 L 98 72 L 87 78 Q 82 81 82 87 L 311 87 L 312 86 L 313 87 L 368 87 L 370 87 Q 374 88 375 86 L 373 82 Q 369 75 361 73 Q 359 69 358 72 Q 354 73 355 71 L 354 71 L 347 70 L 343 68 L 337 68 L 328 65 Q 322 67 323 64 L 322 64 Q 318 65 319 63 L 318 63 L 291 57 Q 285 59 286 56 L 285 56 L 278 55 Q 276 53 275 56 L 275 69 L 275 69 L 181 69 L 181 54 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 96.5 105 L 95.5 107 L 96.5 105 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 365.5 105 L 366.5 107 L 365.5 105 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 245.5 108 L 242.5 112 L 245.5 108 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 97.5 109 L 198 109.5 L 97.5 110 L 97.5 109 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 258.5 109 L 358 109.5 L 258.5 110 L 258.5 109 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 371.5 110 L 372.5 112 L 371.5 110 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 361.5 111 L 366 114.5 L 363.5 113 L 361.5 111 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 368.5 120 L 369 122.5 L 368 122.5 L 368.5 120 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 79.5 121 L 80 211.5 L 79 211.5 L 79.5 121 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 85.5 121 L 86 123.5 L 85 123.5 L 85.5 121 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 55.5 125 L 62 125.5 L 55.5 126 L 55.5 125 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 394.5 125 L 397 125.5 L 394.5 126 L 394.5 125 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 398.5 125 L 402 125.5 L 398.5 126 L 398.5 125 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 85.5 201 L 86 203.5 L 85 203.5 L 85.5 201 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 85.5 205 L 86 209.5 L 85 209.5 L 85.5 205 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 246.5 208 L 247 210.5 L 246 210.5 L 246.5 208 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 86.5 211 L 87.5 213 L 86.5 211 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 248.5 213 L 253 218.5 L 248 214.5 L 248.5 213 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 366.5 214 L 365.5 216 L 366.5 214 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 204.5 216 L 203.5 218 L 204.5 216 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 90.5 217 L 89.5 219 L 90.5 217 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 373.5 217 L 372.5 219 L 373.5 217 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 360.5 219 L 363 220.5 L 361.5 221 L 360.5 219 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 370.5 221 L 369.5 223 L 370.5 221 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 208.5 222 L 207.5 224 L 208.5 222 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 62.5 259 L 63 321.5 Q 62.3 323.8 58.5 323 L 58.5 322 L 62 321.5 L 62.5 259 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 76.5 290 L 78 290.5 L 72 294.5 L 70.5 304 L 69 301.5 Q 71.2 300.2 70 295.5 L 73.5 291 L 76.5 290 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 144.5 290 L 150 293.5 L 151 295.5 L 149 296 L 147.5 292 Q 143.7 292.5 144.5 290 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 309.5 290 L 312 290.5 L 306 294.5 L 305 296.5 L 304.5 335 L 304 296.5 L 309.5 290 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 378.5 290 L 384 292 L 386 296.5 L 386 336.5 L 383 341 L 378.5 342 L 378.5 341 Q 383.5 341.5 384 337.5 L 385 335.5 L 385 296.5 L 381.5 292 Q 377.7 292.5 378.5 290 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 81.5 293 L 141.5 293 L 144 294.5 L 142.5 295 L 141.5 294 L 81.5 294 L 81.5 293 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 315.5 293 L 319 293.5 L 315.5 294 L 315.5 293 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 320.5 293 L 375 293.5 L 320.5 294 L 320.5 293 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 76.5 295 L 74.5 298 L 76.5 295 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 380.5 296 L 382 298.5 L 381 298.5 L 380.5 296 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 151.5 298 L 152 334.5 L 151 334.5 L 151.5 298 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 73.5 299 L 74 327.5 L 73 327.5 L 73.5 299 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 307.5 299 L 308 332.5 L 307 332.5 L 307.5 299 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 382.5 303 L 383 328.5 L 382 328.5 L 382.5 303 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 70.5 320 L 71 336.5 L 73.5 340 L 77 341.5 L 75.5 342 L 71 338.5 L 70 336.5 L 70.5 320 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 395.5 322 L 398 322.5 L 395.5 323 L 395.5 322 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 73.5 329 L 74 332.5 L 73 332.5 L 73.5 329 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 308.5 334 L 311.5 338 L 308.5 334 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 381.5 334 L 378.5 338 L 381.5 334 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 146.5 335 L 144.5 338 L 146.5 335 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 304.5 336 L 308 338 Q 306.9 340.7 309.5 340 L 312.5 342 L 376 342.5 L 312.5 343 L 307 341 L 304.5 336 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 149.5 337 L 151 337.5 L 143.5 343 L 79.5 343 L 79.5 342 L 143.5 342 Q 144.6 339.3 148 340 L 149.5 337 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 139.5 338 L 142 338.5 L 139.5 339 L 139.5 338 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 314.5 338 L 317 338.5 L 314.5 339 L 314.5 338 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 47.5 354 Q 52 353.5 52 354.5 L 52 392 L 147 392 L 151 378.5 L 154 361.5 L 155.5 360 L 158.5 361 L 160.5 361 L 295.5 361 L 297.5 360 L 299.5 361 L 302 360 L 304 365.5 L 306 380.5 L 308 384.5 L 308 390.5 L 309.5 392 L 405 392 L 405 354.5 Q 405 353.5 409.5 354 L 411 356.5 L 410 357.5 L 410 383.5 L 411 384.5 L 411 399.5 L 410 402.5 L 410.5 404 L 408.5 403 L 407.5 404 L 393.5 404 L 392.5 403 L 308.5 403 Q 307.3 405.3 306 402.5 L 305 392.5 L 302 385.5 L 302 379.5 L 299 366 L 158.5 366 L 158 368.5 L 155 377.5 L 155 383.5 Q 151 391.8 151 403 L 62.5 403 L 61.5 404 L 46 404 L 46 359.5 L 47 357.5 L 46 355.5 L 47.5 354 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 215.5 388 L 216 425.5 L 215 425.5 L 215.5 388 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 210.5 414 L 211 425.5 L 210 425.5 L 210.5 414 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 239.5 455 L 255.5 455 Q 256.5 455 256 459.5 L 255 459.5 L 254.5 456 L 239.5 456 L 239.5 455 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 275.5 455 L 292 455.5 L 275 456 L 274.5 460 L 274 456.5 L 275.5 455 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 312.5 455 L 329 455.5 L 312 456 L 311.5 459 L 311 456.5 L 312.5 455 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 349.5 455 L 365.5 455 L 367 456.5 L 366.5 459 L 366 456 L 349.5 456 L 349.5 455 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 218.5 456 L 219 479.5 L 218 479.5 L 218.5 456 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 144.5 458 L 145 461.5 L 144 461.5 L 144.5 458 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 89.5 460 L 90 463.5 L 89 463.5 L 89.5 460 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 293.5 461 L 294 463.5 L 293 463.5 L 293.5 461 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 349.5 461 L 350 463.5 L 349 463.5 L 349.5 461 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 106.5 462 L 107 465.5 L 106 465.5 L 106.5 462 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 181.5 462 L 182 465.5 L 181 465.5 L 181.5 462 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 330.5 462 L 331 464.5 L 330 464.5 L 330.5 462 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 200.5 464 L 201 473.5 L 200 473.5 L 200.5 464 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 312.5 465 L 313 467.5 L 312 467.5 L 312.5 465 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 350.5 466 L 351 470.5 L 350 470.5 L 350.5 466 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 275.5 467 L 276 471.5 L 275 471.5 L 275.5 467 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 331.5 467 L 332 469.5 L 331 469.5 L 331.5 467 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 162.5 469 L 163 476.5 L 162 476.5 L 162.5 469 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 313.5 470 L 314 473.5 L 313 473.5 L 313.5 470 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 142.5 472 L 143 476.5 L 142 476.5 L 142.5 472 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 294.5 472 L 295 479.5 L 294 479.5 L 294.5 472 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 180.5 473 L 181 476.5 L 180 476.5 L 180.5 473 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 332.5 473 L 333 476.5 L 332 476.5 L 332.5 473 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 238.5 474 L 239 519.5 L 238 519.5 L 238.5 474 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 256.5 474 L 257 479.5 L 256 479.5 L 256.5 474 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 370.5 474 L 371 477.5 L 370 477.5 L 370.5 474 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 314.5 476 L 315 479.5 L 314 479.5 L 314.5 476 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 276.5 477 L 277 482.5 L 276 482.5 L 276.5 477 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 352.5 477 L 353 479.5 L 352 479.5 L 352.5 477 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 123.5 480 L 124 483.5 L 123 483.5 L 123.5 480 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 333.5 480 L 334 484.5 L 333 484.5 L 333.5 480 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 353.5 482 L 354 484.5 L 353 484.5 L 353.5 482 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 84.5 483 L 85 485.5 L 84 485.5 L 84.5 483 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 161.5 483 L 162 485.5 L 161 485.5 L 161.5 483 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 179.5 483 L 180 487.5 L 179 487.5 L 179.5 483 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 295.5 483 L 296 487.5 L 295 487.5 L 295.5 483 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 315.5 484 L 316 487.5 L 315 487.5 L 315.5 484 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 122.5 485 L 123 487.5 L 122 487.5 L 122.5 485 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 140.5 488 L 141 492.5 L 140 492.5 L 140.5 488 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 199.5 489 L 200 498.5 L 199 498.5 L 199.5 489 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 160.5 490 L 161 492.5 L 160 492.5 L 160.5 490 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 257.5 491 L 258 498.5 L 257 498.5 L 257.5 491 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 277.5 491 L 278 502.5 L 277 502.5 L 277.5 491 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 296.5 491 L 297 493.5 L 296 493.5 L 296.5 491 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 374.5 491 L 375 494.5 L 374 494.5 L 374.5 491 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 316.5 493 L 317 496.5 L 316 496.5 L 316.5 493 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 100.5 494 L 101 496.5 L 100 496.5 L 100.5 494 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 120.5 495 L 121 500.5 L 120 500.5 L 120.5 495 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 81.5 496 L 82 499.5 L 81 499.5 L 81.5 496 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 139.5 497 L 140 499.5 L 139 499.5 L 139.5 497 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 356.5 497 L 357 499.5 L 356 499.5 L 356.5 497 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 336.5 498 L 337 502.5 L 336 502.5 L 336.5 498 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 375.5 498 L 376 499.5 L 372.5 501 L 372.5 500 Q 376 501 375.5 498 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 159.5 499 L 160 501.5 L 159 501.5 L 159.5 499 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 297.5 499 L 298 506.5 L 297 506.5 L 297.5 499 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 317.5 500 L 318 503.5 L 317 503.5 L 317.5 500 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 69.5 501 L 71 504.5 Q 70.3 506.8 66.5 506 L 66.5 505 Q 71.3 506.7 70 502.5 L 69.5 501 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 90.5 501 L 93 501.5 L 90.5 502 L 90.5 501 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 99.5 501 L 98.5 503 L 96 502.5 L 99.5 501 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 364.5 501 L 368 501.5 L 364.5 502 L 364.5 501 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 387.5 501 Q 391.3 500.3 392 502.5 L 390.5 506 Q 386.8 506.8 386 504.5 L 387.5 501 Z M 387 502 Q 385 507 391 505 Q 393 500 387 502 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 357.5 502 L 362 502.5 L 357.5 503 L 357.5 502 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 178.5 504 L 179 507.5 L 178 507.5 L 178.5 504 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 366.5 505 L 370 506.5 L 368.5 506 L 364.5 508 L 366.5 505 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 88.5 506 L 88 507.5 L 87.5 509 L 87 507.5 L 88.5 506 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 333.5 507 L 336 507.5 L 333.5 508 L 333.5 507 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 127.5 508 L 132 508.5 L 127.5 509 L 127.5 508 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 278.5 508 L 279 512.5 L 278 512.5 L 278.5 508 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 318.5 508 L 323 509.5 L 318 510 L 318.5 508 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 325.5 508 L 331 508.5 L 325.5 509 L 325.5 508 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 91.5 509 L 90.5 511 L 88 510.5 L 91.5 509 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 135.5 509 L 138 509.5 L 135.5 510 L 135.5 509 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 158.5 509 L 159 513.5 L 158 513.5 L 158.5 509 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 258.5 509 L 259 520.5 L 258 520.5 L 258.5 509 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 365.5 509 L 368.5 510 L 370 509.5 L 366.5 511 L 365.5 509 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 110.5 510 L 109.5 512 L 110.5 510 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 198.5 510 L 199 516.5 L 198 516.5 L 198.5 510 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 344.5 510 Q 348.5 509.5 349 512.5 L 347.5 515 L 348 513.5 L 346.5 511 Q 342.8 509.8 344 513.5 L 343 513.5 L 344.5 510 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 112.5 514 L 113 516 L 111 515.5 L 112.5 514 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 293.5 514 L 296 514.5 L 293.5 515 L 293.5 514 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 131.5 515 L 134 515.5 L 131 516 L 132 519.5 L 130 520 Q 129 516.2 131.5 515 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 177.5 515 L 178 517 L 174 516.5 L 177.5 515 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 286.5 515 L 291 515.5 L 286.5 516 L 286.5 515 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 322.5 515 L 326 515.5 L 322.5 516 L 322.5 515 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 322.5 518 L 323.5 520 L 322.5 518 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 326.5 518 L 325.5 520 L 326.5 518 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 208.5 522 L 211 522.5 L 208.5 523 L 208.5 522 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 247.5 522 L 250 522.5 L 247.5 523 L 247.5 522 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 152.5 523 L 155 524.5 L 153.5 525 L 152.5 523 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 301.5 523 L 303.5 524 L 305 523.5 L 302.5 525 L 301.5 523 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 175.5 524 L 178 525.5 L 176.5 525 L 175.5 524 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 280.5 524 L 284 525.5 Q 284.8 529.3 282.5 530 L 279 528.5 L 280.5 529 Q 285.1 530.2 283 525 L 279.5 526 L 280.5 524 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 173.5 528 L 176.5 529 L 178 528.5 L 174.5 530 L 173.5 528 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 196.5 529 L 194.5 532 L 196.5 529 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 198.5 529 L 199.5 531 L 198.5 529 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 258.5 529 L 258 530.5 L 257.5 533 L 257 530.5 L 258.5 529 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(12,11,11)",
    stroke: "rgb(12,11,11)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 199.5 532 L 198.5 534 L 196 533.5 L 199.5 532 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrem);
export default __webpack_public_path__ + "static/media/TREM.b950be46df0264f094bd9e5133897c9c.svg";
export { ForwardRef as ReactComponent };